import {
  Box,
  Icon,
  SimpleGrid,
  useColorModeValue,
  VStack,
  HStack,
  Heading,
  Text,
  Card,
  Flex,
  Badge,
  Select,
  Button,
  ButtonGroup,
  Progress,
  Input,
  InputGroup,
  InputLeftElement,
  Switch,
  InputRightElement,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Avatar,
} from "@chakra-ui/react";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
import {
  MdAddTask,
  MdOutlineFireTruck,
  MdAccessTime,
  MdTimer,
  MdCheckCircle,
  MdTrendingUp,
  MdInfo,
  MdRoute,
  MdPerson,
  MdCalendarToday,
  MdShield,
  MdBarChart,
  MdPieChart,
  MdMap,
  MdLocalHospital,
  MdBuild,
  MdFileDownload,
  MdSearch,
  MdRemove,
  MdTrendingDown,
  MdCenterFocusStrong,
  MdPictureAsPdf,
  MdShowChart,
  MdArrowDropDown,
  MdStar,
  MdChevronRight,
  MdClose,
} from "react-icons/md";
import { MdArrowUpward, MdArrowDownward } from "react-icons/md";
import config from "config/api";
import Chart from "react-apexcharts";
import { Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react";
import { useAnalyses } from "contexts/AnalysesContext";
import { useGoogleMaps } from "components/GoogleMapsLoader";
import LoadingSpinner from "components/LoadingSpinner";
import { genererRapportQuotidienAmbulancesExcel } from "services/rapportQuotidienAmbulancesExcelService";
import { usePermissions } from "hooks/usePermissions";

export default function Analyses() {
  const navigate = useNavigate();
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const cardBg = useColorModeValue("white", "navy.800");
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = useColorModeValue("secondaryGray.600", "white");
  const { hasPermission } = usePermissions();

  // États pour les filtres - depuis le contexte
  const { selectedPeriod, dateRange, selectedVille, selectedRegion, selectedAnalyses } = useAnalyses();
  const selectedAnalysesList = Array.isArray(selectedAnalyses) ? selectedAnalyses : [selectedAnalyses];
  const isAnalysisSelected = (analysisKey) => selectedAnalysesList.includes('tous') || selectedAnalysesList.includes(analysisKey);
  const [missionFilter, setMissionFilter] = useState('tous');
  const [qualiteFilter, setQualiteFilter] = useState('tous');
  const [geographiqueFilter, setGeographiqueFilter] = useState('tous');
  const [medicalFilter, setMedicalFilter] = useState('urgences-vitales');
  const [performanceFilter, setPerformanceFilter] = useState('ambulancier');
  const [performanceSearch, setPerformanceSearch] = useState('');

  // États pour les données
  const [activiteData, setActiviteData] = useState({
    missionsTotales: { valeur: 0, valeurPrecedente: 0, differencePourcentage: 0 },
    missionsUrgentes: { valeur: 0, valeurPrecedente: 0, differencePourcentage: 0 },
    missionsPlanifiees: { valeur: 0, valeurPrecedente: 0, differencePourcentage: 0 },
    tauxPerformance: { valeur: 0, differencePourcentage: 0 },
    missionsTotalesApplication: 0,
    missionsTotalesTelephone: 0,
    missionsUrgentesApplication: 0,
    missionsUrgentesTelephone: 0,
    missionsPlanifieesApplication: 0,
    missionsPlanifieesTelephone: 0
  });
  const [loadingActivite, setLoadingActivite] = useState(false);

  const [missionsData, setMissionsData] = useState({
    dureeTotaleMoyenne: { valeur: 0, valeurPrecedente: 0, differencePourcentage: 0 },
    delaiIntervention: { valeur: 0, valeurPrecedente: 0, differencePourcentage: 0 },
    delaiAffectation: { valeur: 0, valeurPrecedente: 0, differencePourcentage: 0 },
    delaiSurSite: { valeur: 0, valeurPrecedente: 0, differencePourcentage: 0 }
  });
  const [loadingMissions, setLoadingMissions] = useState(false);

  // Données pour les graphiques des ambulances
  const [ambulancesData, setAmbulancesData] = useState({
    missionsParAmbulance: [],
    categories: [],
    disponibilite: { disponible: 0, utilisation: 0, maintenance: 0 },
    tauxDisponibiliteGlobal: { taux_utilisation: 0, taux_disponibilite: 0 },
    typeAmbulances: [],
    typeMissions: [],
    tauxGravite: []
  });
  const [loadingAmbulances, setLoadingAmbulances] = useState(false);

  const [transportData] = useState({
    medicalisee: 101,
    simple: 89,
    total: 210
  });

  const [typeMissionsData] = useState({
    urgentes: 687,
    planifiees: 1506,
    total: 2193
  });

  const [graviteData] = useState({
    vitale: 12,
    elevee: 21,
    nonVitale: 18,
    total: 51
  });

  // Données factices pour la section Performance
  const [performancePersonnes, setPerformancePersonnes] = useState([]);
  const [loadingPerformance, setLoadingPerformance] = useState(false);
  const [selectedPerformanceUser, setSelectedPerformanceUser] = useState(null);
  const [userDetailData, setUserDetailData] = useState(null);
  const [loadingUserDetail, setLoadingUserDetail] = useState(false);
  const { isOpen: isUserDetailOpen, onOpen: onUserDetailOpen, onClose: onUserDetailClose } = useDisclosure();

  const [performanceData, setPerformanceData] = useState({
    metrics: {
      missionsTotales: { valeur: 0, evolution: 0, type: 'min' },
      missionsAcceptees: { valeur: 0, evolution: 0, type: 'min' },
      missionsAnnulees: { valeur: 0, evolution: 0, type: '%' },
      delaiAcceptation: { valeur: '0 Sec', evolution: null },
      delaiIntervention: { valeur: '0 min', evolution: null },
      delaiMissions: { valeur: '0 min', evolution: null },
      nombreReclamations: { valeur: 0, evolution: null }
    }
  });

  // Données pour la section Qualité & Conformité (remplies par l'API /analyses/conformite)
  const [qualiteData, setQualiteData] = useState({
    reclamationsTotales: { valeur: 0, evolution: 0, type: 'min' },
    tauxReclamation: { valeur: 0, evolution: 0, type: 'min' },
    delaiTraitement: { valeur: '0 min', evolution: 0, type: '%' },
    tauxSatisfaction: { valeur: 0, evolution: 0, type: '%' },
    evolutionReclamations: {
      categories: [],
      series: []
    },
    repartitionType: {
      retard: { valeur: 0, couleur: '#F8285A' },
      qualitePriseEnCharge: { valeur: 0, couleur: '#F6B100' },
      defaillancePriseEnCharge: { valeur: 0, couleur: '#34C759' },
      hygiene: { valeur: 0, couleur: '#006133' },
      facturation: { valeur: 0, couleur: '#CB30E0' },
      securite: { valeur: 0, couleur: '#7239EA' },
      comportement: { valeur: 0, couleur: '#656C7A' },
      autre: { valeur: 0, couleur: '#98A2B3' }
    }
  });

  // Données pour la section Analyse Géographique
  const [geographiqueData, setGeographiqueData] = useState({
    missionsUrbaines: { valeur: 0, pourcentage: 0 },
    missionsInterurbaines: { valeur: 0, pourcentage: 0 },
    rayonPlus50km: { valeur: 0, pourcentage: 0 },
    statistiques: {
      totalPoints: 0,
      consultationDomicile: 0,
      ambulance: 0,
      acteInfirmier: 0
    },
    missions: []
  });
  const [loadingGeographique, setLoadingGeographique] = useState(false);
  const [mapZoom, setMapZoom] = useState(10);
  const mapRef = React.useRef(null);
  const mapInstance = React.useRef(null);
  const markersRef = React.useRef([]);
  const { loaded: googleMapsLoaded } = useGoogleMaps();



  // Données pour la section Flotte & Maintenance (remplies par l'API /analyses/flotte-maintenance)
  const [flotteData, setFlotteData] = useState({
    vehiculesActifs: { valeur: 0, description: 'Flotte opérationnelle' },
    pannes: { valeur: 0, evolution: 0, type: 'pannes' },
    entretiens: { valeur: 0, evolution: 0, type: 'pannes' },
    pannesToSoon: { valeur: 0 },
    pannesUrgent: { valeur: 0 },
    pannesParVehicule: {
      vehicules: [],
      valeurs: [],
      couleurs: []
    },
    repartitionType: {
      reparation: { valeur: 0, couleur: '#F8285A' },
      maintenance: { valeur: 0, couleur: '#F6B100' },
      gasoil: { valeur: 0, couleur: '#34C759' }
    }
  });
  const [loadingFlotte, setLoadingFlotte] = useState(false);

  // Données pour la section Analyse des médecins prescripteurs (remplies par l'API /analyses/medecins-prescripteurs)
  const [medecinsData, setMedecinsData] = useState({
    medecins: [],
    tauxMissionEnvoyees: [],
    tauxMissionRecues: []
  });
  const [loadingMedecins, setLoadingMedecins] = useState(false);
  const [searchMedecin, setSearchMedecin] = useState('');
  const [searchHopital, setSearchHopital] = useState('');

  // État pour le rapport quotidien ambulances
  const todayStr = new Date().toISOString().split('T')[0];
  const [rapportDate, setRapportDate] = useState(todayStr);
  const [rapportEtat, setRapportEtat] = useState('tous');
  const [rapportLoading, setRapportLoading] = useState(false);
  const { isOpen: isRapportOpen, onOpen: onRapportOpen, onClose: onRapportClose } = useDisclosure();

  const handleGenererRapport = async () => {
    setRapportLoading(true);
    try {
      const params = new URLSearchParams({ date: rapportDate });
      if (rapportEtat !== 'tous') params.append('etat', rapportEtat);
      const response = await axios.get(
        `${config.apiBaseUrl}/analyses/rapport-quotidien-ambulances?${params.toString()}`
      );
      const { date, resume, missions } = response.data;
      genererRapportQuotidienAmbulancesExcel({ date, resume, missions });
      onRapportClose();
    } catch (err) {
      console.error('Erreur génération rapport:', err);
    } finally {
      setRapportLoading(false);
    }
  };

  // Fonction pour formater les minutes en HH:MM ou MM:SS selon la durée
  const minutesToMMSS = (minutes) => {
    const totalMinutes = Math.floor(minutes);
    const secs = Math.floor((minutes - totalMinutes) * 60);

    // Si plus de 60 minutes, afficher en heures:minutes
    if (totalMinutes >= 60) {
      const hours = Math.floor(totalMinutes / 60);
      const mins = totalMinutes % 60;
      return `${hours}h ${mins.toString().padStart(2, '0')}min`;
    }

    // Sinon, afficher en minutes:secondes avec "min"
    return `${totalMinutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')} min`;
  };

  // Fonction pour formater les évolutions
  const formatEvolution = (differencePourcentage) => {
    const isPositive = differencePourcentage >= 0;
    const color = isPositive ? "green.500" : "red.500";
    const icon = isPositive ? "arrow-up" : "arrow-down";
    return {
      color,
      icon,
      text: `${isPositive ? '+' : ''}${differencePourcentage.toFixed(1)}%`
    };
  };

  // Fonction pour obtenir le texte de comparaison
  const getComparisonText = (period) => {
    const comparisons = {
      aujourdhui: "vs hier",
      jour: "vs hier",
      semaine: "vs semaine dernière",
      mois: "vs mois dernier",
      trimestre: "vs trimestre dernier",
      annee: "vs année dernière",
      periode: "vs période précédente"
    };
    return comparisons[period] || "vs période précédente";
  };

  // Fonction pour formater la date en YYYY-MM-DD
  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Fonction pour calculer le pourcentage pour les graphiques radiaux
  const calculateRadialPercentage = (application, telephone) => {
    const total = application + telephone;
    if (total === 0) return 0;
    return (application / total) * 100;
  };

  // Fonction pour récupérer les données d'activité opérationnelle
  const fetchActiviteOperationnelle = useCallback(async () => {
    setLoadingActivite(true);
    try {
      const params = new URLSearchParams();

      // Ajouter la période
      if (selectedPeriod === 'custom' && dateRange[0] && dateRange[1]) {
        params.append('periode', 'periode');
        params.append('date_debut', formatDate(dateRange[0]));
        params.append('date_fin', formatDate(dateRange[1]));
      } else if (selectedPeriod) {
        params.append('periode', selectedPeriod);
      }

      // Ajouter la ville si sélectionnée
      if (selectedVille && selectedVille !== 'tous') {
        params.append('ville', selectedVille);
      }

      const [activiteResponse, perfResponse] = await Promise.allSettled([
        axios.get(`${config.apiBaseUrl}/analyses/activite-operationnelle?${params.toString()}`),
        axios.get(`${config.apiBaseUrl}/analyses/perf?${params.toString()}`)
      ]);

      const activiteData = activiteResponse.status === 'fulfilled' ? activiteResponse.value.data : null;
      const perfData = perfResponse.status === 'fulfilled' ? perfResponse.value.data : null;

      if (activiteData && activiteData.statistiques) {
        const stats = activiteData.statistiques;

        // Calculer les différences de pourcentage (simulation - à adapter selon l'API réelle)
        const calculateDifference = (current, previous) => {
          if (!previous || previous === 0) return 0;
          return ((current - previous) / previous) * 100;
        };

        // Récupérer le taux de performance global depuis l'API perf
        const tauxPerformanceGlobal = perfData?.taux_performance_global || 0;

        setActiviteData({
          missionsTotales: {
            valeur: stats.missions_totales || 0,
            valeurPrecedente: 0, // L'API ne fournit pas cette info, à adapter
            differencePourcentage: 0 // À calculer si l'API fournit les données précédentes
          },
          missionsUrgentes: {
            valeur: stats.missions_urgentes || 0,
            valeurPrecedente: 0,
            differencePourcentage: 0
          },
          missionsPlanifiees: {
            valeur: stats.missions_planifiees || 0,
            valeurPrecedente: 0,
            differencePourcentage: 0
          },
          tauxPerformance: {
            valeur: parseFloat(tauxPerformanceGlobal.toFixed(1)),
            differencePourcentage: 0
          },
          missionsTotalesApplication: stats.missions_totales_application || 0,
          missionsTotalesTelephone: stats.missions_totales_telephone || 0,
          missionsUrgentesApplication: stats.missions_urgentes_application || 0,
          missionsUrgentesTelephone: stats.missions_urgentes_telephone || 0,
          missionsPlanifieesApplication: stats.missions_planifiees_application || 0,
          missionsPlanifieesTelephone: stats.missions_planifiees_telephone || 0
        });
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des données d\'activité opérationnelle:', error);
      // En cas d'erreur, garder les valeurs par défaut
    } finally {
      setLoadingActivite(false);
    }
  }, [selectedPeriod, dateRange, selectedVille]);

  // Fonction pour mapper le filtre local au type de mission de l'API
  const mapMissionFilterToAPI = (filter) => {
    const mapping = {
      'tous': null,
      'ambulance': 'ambulance',
      'teleconsultation': 'teleconsultation',
      'medecin': 'Consultation à domicile',
      'acte-infirmier': 'acte infirmier'
    };
    return mapping[filter] || null;
  };

  // Fonction pour récupérer les données des missions
  const fetchMissions = useCallback(async () => {
    setLoadingMissions(true);
    try {
      const params = new URLSearchParams();

      // Ajouter la période
      if (selectedPeriod === 'custom' && dateRange[0] && dateRange[1]) {
        params.append('periode', 'periode');
        params.append('date_debut', formatDate(dateRange[0]));
        params.append('date_fin', formatDate(dateRange[1]));
      } else if (selectedPeriod) {
        params.append('periode', selectedPeriod);
      }

      // Ajouter la ville si sélectionnée
      if (selectedVille && selectedVille !== 'tous') {
        params.append('ville', selectedVille);
      }

      // Ajouter le type de mission si sélectionné
      const typeMission = mapMissionFilterToAPI(missionFilter);
      if (typeMission) {
        params.append('typemission', typeMission);
      }

      const response = await axios.get(`${config.apiBaseUrl}/analyses/missions?${params.toString()}`);
      const data = response.data;

      if (data && data.statistiques) {
        const stats = data.statistiques;

        // Convertir les valeurs string en nombres et convertir les secondes en minutes
        const parseFloatValue = (value) => {
          if (typeof value === 'string') {
            return parseFloat(value) || 0;
          }
          return value || 0;
        };

        // Fonction pour convertir les secondes en minutes
        const secondsToMinutes = (seconds) => {
          const secs = parseFloatValue(seconds);
          return secs / 60; // Convertir secondes en minutes
        };

        setMissionsData({
          dureeTotaleMoyenne: {
            valeur: secondsToMinutes(stats.duree_totale_moyenne_mission),
            valeurPrecedente: 0, // L'API ne fournit pas cette info, à adapter
            differencePourcentage: 0 // À calculer si l'API fournit les données précédentes
          },
          delaiIntervention: {
            valeur: secondsToMinutes(stats.delai_moyen_intervention),
            valeurPrecedente: 0,
            differencePourcentage: 0
          },
          delaiAffectation: {
            valeur: secondsToMinutes(stats.delai_moyen_affectation),
            valeurPrecedente: 0,
            differencePourcentage: 0
          },
          delaiSurSite: {
            valeur: secondsToMinutes(stats.delai_moyen_sur_site),
            valeurPrecedente: 0,
            differencePourcentage: 0
          }
        });
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des données des missions:', error);
      // En cas d'erreur, garder les valeurs par défaut
    } finally {
      setLoadingMissions(false);
    }
  }, [selectedPeriod, dateRange, selectedVille, missionFilter]);

  // Fonction pour récupérer les données de performance
  const fetchPerformance = useCallback(async () => {
    setLoadingPerformance(true);
    try {
      const params = new URLSearchParams();

      // Ajouter le rôle si un filtre est sélectionné (premier paramètre)
      if (performanceFilter && performanceFilter !== 'tous') {
        const roleMapping = {
          'ambulancier': 'ambulancier',
          'medecin': 'medecin',
          'infirmier': 'infirmier',
          'regulateur': 'regulateur'
        };
        const roleValue = roleMapping[performanceFilter] || performanceFilter;
        if (roleValue) {
          params.append('role', roleValue);
        }
      }

      // Ajouter la période (deuxième paramètre)
      if (selectedPeriod === 'custom' && dateRange[0] && dateRange[1]) {
        params.append('periode', 'periode');
        params.append('date_debut', formatDate(dateRange[0]));
        params.append('date_fin', formatDate(dateRange[1]));
      } else if (selectedPeriod && selectedPeriod !== 'custom') {
        params.append('periode', selectedPeriod);
      }

      // Ajouter la ville si sélectionnée (dernier paramètre)
      if (selectedVille && selectedVille !== 'tous') {
        params.append('ville', selectedVille);
      }

      const response = await axios.get(`${config.apiBaseUrl}/analyses/perf?${params.toString()}`);
      const data = response.data;

      if (data && data.performances_par_user) {
        // Transformer les données de l'API pour correspondre à la structure de l'interface
        const personnes = data.performances_par_user.map((user, index) => ({
          id: user.user_id || index + 1,
          nom: `${user.prenom || ''} ${user.nom || ''}`.trim() || 'Utilisateur',
          code: `P-${String(user.user_id || index + 1).padStart(3, '0')}`,
          etoile_globale: parseFloat(user.etoile_globale || 0),
          selected: index === 0, // Sélectionner le premier par défaut
          user_id: user.user_id,
          photo: user.photo,
          role: user.role,
          nombre_missions: user.nombre_missions || 0,
          temps_reactivite: user.temps_reactivite,
          respect_delais_intervention: user.respect_delais_intervention,
          satisfaction_patient: user.satisfaction_patient,
          performance_globale: parseFloat(user.performance_globale || 0)
        }));

        setPerformancePersonnes(personnes);

        // Si une personne est sélectionnée, charger ses détails
        const selectedPerson = personnes.find(p => p.selected) || personnes[0];
        if (selectedPerson) {
          setSelectedPerformanceUser(selectedPerson);
          // Mettre à jour les métriques avec les données de l'utilisateur sélectionné
          setPerformanceData({
            metrics: {
              missionsTotales: {
                valeur: selectedPerson.nombre_missions || 0,
                evolution: 0,
                type: 'min'
              },
              missionsAcceptees: {
                valeur: selectedPerson.nombre_missions_acceptees ?? selectedPerson.nombre_missions ?? 0,
                evolution: 0,
                type: 'min'
              },
              missionsAnnulees: {
                valeur: selectedPerson.nombre_missions_annulees ?? 0,
                evolution: 0,
                type: '%'
              },
              delaiAcceptation: {
                valeur: `${Math.round(parseFloat(selectedPerson.temps_reactivite?.moyenne_secondes || 0))} Sec`,
                evolution: null
              },
              delaiIntervention: {
                valeur: selectedPerson.delai_moyen_intervention_minutes != null
                  ? `${selectedPerson.delai_moyen_intervention_minutes} min`
                  : `${Math.round(parseFloat(selectedPerson.respect_delais_intervention?.moyenne_secondes || 0) / 60)} min`,
                evolution: null
              },
              delaiMissions: {
                valeur: selectedPerson.delai_moyen_missions_minutes != null
                  ? `${selectedPerson.delai_moyen_missions_minutes} min`
                  : '0 min',
                evolution: null
              },
              nombreReclamations: {
                valeur: selectedPerson.nombre_reclamations ?? 0,
                evolution: null
              }
            }
          });
        }
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des données de performance:', error);
      // En cas d'erreur, garder les valeurs par défaut
    } finally {
      setLoadingPerformance(false);
    }
  }, [selectedPeriod, dateRange, selectedVille, performanceFilter]);

  // useEffect pour charger les données quand les filtres changent
  useEffect(() => {
    fetchActiviteOperationnelle();
  }, [fetchActiviteOperationnelle]);

  // useEffect pour charger les données de performance quand les filtres changent
  useEffect(() => {
    fetchPerformance();
  }, [fetchPerformance]);

  // Fonction pour récupérer les détails d'un utilisateur
  const fetchUserDetail = useCallback(async (userId) => {
    if (!userId) return;

    setLoadingUserDetail(true);
    try {
      const params = new URLSearchParams();

      // Ajouter la période
      if (selectedPeriod === 'custom' && dateRange[0] && dateRange[1]) {
        params.append('periode', 'periode');
        params.append('date_debut', formatDate(dateRange[0]));
        params.append('date_fin', formatDate(dateRange[1]));
      } else if (selectedPeriod) {
        params.append('periode', selectedPeriod);
      }

      // Ajouter la ville si sélectionnée
      if (selectedVille && selectedVille !== 'tous') {
        params.append('ville', selectedVille);
      }

      const response = await axios.get(`${config.apiBaseUrl}/analyses/perf_user/${userId}?${params.toString()}`);
      const data = response.data;
      setUserDetailData(data);
      // Mettre à jour selectedPerformanceUser avec les données complètes de l'API
      if (data && data.performance_user) {
        const perfUser = data.performance_user;
        setSelectedPerformanceUser({
          id: perfUser.user_id,
          nom: `${perfUser.prenom || ''} ${perfUser.nom || ''}`.trim() || 'Utilisateur',
          code: `${String(perfUser.user_id || 0).padStart(3, '0')}`,
          etoile_globale: parseFloat(perfUser.etoile_globale || 0),
          user_id: perfUser.user_id,
          photo: perfUser.photo,
          role: perfUser.role,
          nombre_missions: perfUser.nombre_missions || 0,
          nombre_missions_acceptees: perfUser.nombre_missions_acceptees ?? perfUser.nombre_missions ?? 0,
          nombre_missions_annulees: perfUser.nombre_missions_annulees ?? 0,
          nombre_reclamations: perfUser.nombre_reclamations ?? 0,
          delai_moyen_intervention_minutes: perfUser.delai_moyen_intervention_minutes ?? null,
          delai_moyen_missions_minutes: perfUser.delai_moyen_missions_minutes ?? null,
          temps_reactivite: perfUser.temps_reactivite,
          respect_delais_intervention: perfUser.respect_delais_intervention,
          satisfaction_patient: perfUser.satisfaction_patient,
          performance_globale: parseFloat(perfUser.performance_globale || 0)
        });
        setPerformanceData(prev => ({
          metrics: {
            ...prev.metrics,
            missionsTotales: { ...prev.metrics.missionsTotales, valeur: perfUser.nombre_missions ?? 0 },
            missionsAcceptees: { ...prev.metrics.missionsAcceptees, valeur: perfUser.nombre_missions_acceptees ?? perfUser.nombre_missions ?? 0 },
            missionsAnnulees: { ...prev.metrics.missionsAnnulees, valeur: perfUser.nombre_missions_annulees ?? 0 },
            delaiAcceptation: {
              ...prev.metrics.delaiAcceptation,
              valeur: `${Math.round(parseFloat(perfUser.temps_reactivite?.moyenne_secondes || 0))} Sec`
            },
            delaiIntervention: {
              ...prev.metrics.delaiIntervention,
              valeur: perfUser.delai_moyen_intervention_minutes != null
                ? `${perfUser.delai_moyen_intervention_minutes} min`
                : `${Math.round(parseFloat(perfUser.respect_delais_intervention?.moyenne_secondes || 0) / 60)} min`
            },
            delaiMissions: {
              ...prev.metrics.delaiMissions,
              valeur: perfUser.delai_moyen_missions_minutes != null
                ? `${perfUser.delai_moyen_missions_minutes} min`
                : '0 min'
            },
            nombreReclamations: { valeur: perfUser.nombre_reclamations ?? 0, evolution: null }
          }
        }));
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des détails de l\'utilisateur:', error);
      setUserDetailData(null);
    } finally {
      setLoadingUserDetail(false);
    }
  }, [selectedPeriod, dateRange, selectedVille]);

  // useEffect pour recharger les détails de l'utilisateur quand les filtres changent
  useEffect(() => {
    if (selectedPerformanceUser?.user_id) {
      fetchUserDetail(selectedPerformanceUser.user_id);
    }
  }, [selectedPerformanceUser?.user_id, fetchUserDetail]);

  // Fonction pour récupérer les données des ambulances
  const fetchAmbulances = useCallback(async () => {
    setLoadingAmbulances(true);
    try {
      const params = new URLSearchParams();

      // Ajouter la période
      if (selectedPeriod === 'custom' && dateRange[0] && dateRange[1]) {
        params.append('periode', 'periode');
        params.append('date_debut', formatDate(dateRange[0]));
        params.append('date_fin', formatDate(dateRange[1]));
      } else if (selectedPeriod) {
        params.append('periode', selectedPeriod);
      }

      // Ajouter la ville si sélectionnée
      if (selectedVille && selectedVille !== 'tous') {
        params.append('ville', selectedVille);
      }

      const response = await axios.get(`${config.apiBaseUrl}/analyses/Analyse-des-ambulances?${params.toString()}`);
      const data = response.data;

      if (data) {
        // Extraire les données des ambulances
        const missionsParAmbulance = data.ambulances ? data.ambulances.map(amb => amb.nombre_missions || 0) : [];
        const categories = data.ambulances ? data.ambulances.map(amb => amb.immatriculation || `AMB-${amb.ambulance_id}`) : [];

        // Extraire les taux de disponibilité
        const tauxDisponibilite = data.taux_disponibilite_global ? parseFloat(data.taux_disponibilite_global.taux_disponibilite) || 0 : 0;
        const tauxUtilisation = data.taux_disponibilite_global ? parseFloat(data.taux_disponibilite_global.taux_utilisation) || 0 : 0;
        // Le taux de maintenance peut être calculé comme le reste (100 - disponibilité - utilisation)
        // ou peut-être fourni par l'API, pour l'instant on le calcule
        const tauxMaintenance = Math.max(0, 100 - tauxDisponibilite - tauxUtilisation);

        setAmbulancesData({
          missionsParAmbulance,
          categories,
          disponibilite: {
            disponible: tauxDisponibilite,
            utilisation: tauxUtilisation,
            maintenance: tauxMaintenance
          },
          tauxDisponibiliteGlobal: data.taux_disponibilite_global || { taux_utilisation: 0, taux_disponibilite: 0 },
          typeAmbulances: data.type_ambulances || [],
          typeMissions: data.type_missions || [],
          tauxGravite: data.taux_gravite || []
        });
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des données des ambulances:', error);
      // En cas d'erreur, garder les valeurs par défaut
      setAmbulancesData({
        missionsParAmbulance: [],
        categories: [],
        disponibilite: { disponible: 0, utilisation: 0, maintenance: 0 },
        tauxDisponibiliteGlobal: { taux_utilisation: 0, taux_disponibilite: 0 },
        typeAmbulances: [],
        typeMissions: [],
        tauxGravite: []
      });
    } finally {
      setLoadingAmbulances(false);
    }
  }, [selectedPeriod, dateRange, selectedVille]);

  // useEffect pour charger les données des missions quand les filtres changent
  useEffect(() => {
    fetchMissions();
  }, [fetchMissions]);

  // Fonction pour mapper le filtre géographique au type de mission de l'API
  const mapGeographiqueFilterToAPI = (filter) => {
    const mapping = {
      'tous': null,
      'ambulancier': 'ambulance',
      'medecin': 'Consultation à domicile',
      'acte-infirmier': 'acte infirmier',
      'regulateur': null // Régulateur n'est pas un type de mission
    };
    return mapping[filter] || null;
  };

  // Fonction pour récupérer les données géographiques
  const fetchGeographique = useCallback(async () => {
    setLoadingGeographique(true);
    try {
      const params = new URLSearchParams();

      // Ajouter la période
      if (selectedPeriod === 'custom' && dateRange[0] && dateRange[1]) {
        params.append('periode', 'periode');
        params.append('date_debut', formatDate(dateRange[0]));
        params.append('date_fin', formatDate(dateRange[1]));
      } else if (selectedPeriod) {
        params.append('periode', selectedPeriod);
      }

      // Ajouter la ville si sélectionnée
      if (selectedVille && selectedVille !== 'tous') {
        params.append('ville', selectedVille);
      }

      // Ajouter le type de mission si sélectionné
      const typeMission = mapGeographiqueFilterToAPI(geographiqueFilter);
      if (typeMission) {
        params.append('typemission', typeMission);
      }

      const response = await axios.get(`${config.apiBaseUrl}/analyses/geographique?${params.toString()}`);
      const data = response.data;

      if (data) {
        const missionsParPerimetre = data.missions_par_perimetre || {};
        const total = missionsParPerimetre.total || 0;

        // Calculer les pourcentages
        const missionsUrbaines = missionsParPerimetre.missions_urbaines || 0;
        const missionsInterurbaines = missionsParPerimetre.missions_interurbaines || 0;
        const rayonPlus50km = missionsParPerimetre.rayon_plus_50km || 0;

        const pourcentageUrbaines = total > 0 ? (missionsUrbaines / total) * 100 : 0;
        const pourcentageInterurbaines = total > 0 ? (missionsInterurbaines / total) * 100 : 0;
        const pourcentageRayon = total > 0 ? (rayonPlus50km / total) * 100 : 0;

        // Extraire les statistiques
        const stat = data.stat || {};

        setGeographiqueData({
          missionsUrbaines: {
            valeur: missionsUrbaines,
            pourcentage: pourcentageUrbaines
          },
          missionsInterurbaines: {
            valeur: missionsInterurbaines,
            pourcentage: pourcentageInterurbaines
          },
          rayonPlus50km: {
            valeur: rayonPlus50km,
            pourcentage: pourcentageRayon
          },
          statistiques: {
            totalPoints: total,
            consultationDomicile: stat['Consultation à domicile'] || 0,
            ambulance: stat['Ambulance'] || 0,
            acteInfirmier: stat['Acte infirmier'] || 0
          },
          missions: data.missions || []
        });
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des données géographiques:', error);
      // En cas d'erreur, garder les valeurs par défaut
      setGeographiqueData({
        missionsUrbaines: { valeur: 0, pourcentage: 0 },
        missionsInterurbaines: { valeur: 0, pourcentage: 0 },
        rayonPlus50km: { valeur: 0, pourcentage: 0 },
        statistiques: {
          totalPoints: 0,
          consultationDomicile: 0,
          ambulance: 0,
          acteInfirmier: 0
        },
        missions: []
      });
    } finally {
      setLoadingGeographique(false);
    }
  }, [selectedPeriod, dateRange, selectedVille, geographiqueFilter]);

  

  // Fonction pour récupérer les données de Qualité & Conformité
  const fetchQualiteConformite = useCallback(async () => {
    try {
      const params = new URLSearchParams();

      // Ajouter la période
      if (selectedPeriod === 'custom' && dateRange[0] && dateRange[1]) {
        params.append('periode', 'periode');
        params.append('date_debut', formatDate(dateRange[0]));
        params.append('date_fin', formatDate(dateRange[1]));
      } else if (selectedPeriod) {
        params.append('periode', selectedPeriod);
      }

      // Ajouter la ville si sélectionnée
      if (selectedVille && selectedVille !== 'tous') {
        params.append('ville', selectedVille);
      }

      const response = await axios.get(`${config.apiBaseUrl}/analyses/conformite?${params.toString()}`);
      const data = response.data;

      if (data && data.conformite) {
        const conf = data.conformite || {};

        // Préparer la répartition par motif avec les mêmes clés que l'UI actuelle
        const baseRepartition = {
          retard: { valeur: 0, couleur: '#F8285A' },
          qualitePriseEnCharge: { valeur: 0, couleur: '#F6B100' },
          defaillancePriseEnCharge: { valeur: 0, couleur: '#34C759' },
          hygiene: { valeur: 0, couleur: '#006133' },
          facturation: { valeur: 0, couleur: '#CB30E0' },
          securite: { valeur: 0, couleur: '#7239EA' },
          comportement: { valeur: 0, couleur: '#656C7A' },
          autre: { valeur: 0, couleur: '#98A2B3' }
        };

        if (Array.isArray(data.repartitionParMotif)) {
          data.repartitionParMotif.forEach((item) => {
            const motif = (item.motif || '').trim();
            const total = item.total || 0;
            if (!motif) {
              baseRepartition.autre.valeur += total;
              return;
            }
            if (motif === 'Retard') {
              baseRepartition.retard.valeur = total;
            } else if (motif === 'Comportement') {
              baseRepartition.comportement.valeur = total;
            } else if (motif === 'Qualité de prise en charge' || motif.includes('Qualité')) {
              baseRepartition.qualitePriseEnCharge.valeur = total;
            } else if (motif === 'Défaillance de prise en charge' || motif.includes('Défaillance')) {
              baseRepartition.defaillancePriseEnCharge.valeur = total;
            } else if (motif === 'Hygiène') {
              baseRepartition.hygiene.valeur = total;
            } else if (motif === 'Facturation') {
              baseRepartition.facturation.valeur = total;
            } else if (motif === 'Sécurité') {
              baseRepartition.securite.valeur = total;
            } else if (motif === 'Soins') {
              baseRepartition.qualitePriseEnCharge.valeur += total;
            } else if (motif === 'Autre') {
              baseRepartition.autre.valeur += total;
            } else {
              baseRepartition.autre.valeur += total;
            }
          });
        }

        // Préparer les données pour l'évolution des réclamations (graphique en aire)
        const nomsMois = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
        let evoCategories = [];
        let evoSeries = [];
        if (Array.isArray(data.evolutionReclamationsAnnuelle) && data.evolutionReclamationsAnnuelle.length > 0) {
          evoCategories = nomsMois;
          const parMois = {};
          data.evolutionReclamationsAnnuelle.forEach((e) => {
            const m = e.mois >= 1 && e.mois <= 12 ? e.mois : null;
            if (m != null) parMois[m] = e.total ?? 0;
          });
          evoSeries = Array.from({ length: 12 }, (_, i) => parMois[i + 1] ?? 0);
        } else {
          const evo = Array.isArray(data.evolutionReclamations) ? data.evolutionReclamations : [];
          evoCategories = evo.map((e) => e.periode || '');
          evoSeries = evo.map((e) => e.total || 0);
        }

        const delaiVal = conf.delaiTraitementMoyen?.valeur ?? 0;
        const delaiUnite = conf.delaiTraitementMoyen?.unite || 'minutes';

        // Convertir en minutes d'abord
        let totalMinutes = delaiVal;
        if (delaiUnite === 'heures' || delaiUnite === 'hours') {
          totalMinutes = delaiVal * 60;
        } else if (delaiUnite === 'jours' || delaiUnite === 'days') {
          totalMinutes = delaiVal * 60 * 24;
        }

        // Convertir en jours et heures
        const jours = Math.floor(totalMinutes / (60 * 24));
        const heuresRestantes = Math.floor((totalMinutes % (60 * 24)) / 60);
        const minutesRestantes = Math.round(totalMinutes % 60);

        let delaiTexte = '';
        if (jours > 0) {
          delaiTexte = `${jours}j ${heuresRestantes}h`;
        } else if (heuresRestantes > 0) {
          delaiTexte = `${heuresRestantes}h ${minutesRestantes}min`;
        } else {
          delaiTexte = `${minutesRestantes} min`;
        }

        setQualiteData((prev) => ({
          ...prev,
          reclamationsTotales: {
            ...prev.reclamationsTotales,
            valeur: conf.totalReclamations ?? 0
          },
          tauxReclamation: {
            ...prev.tauxReclamation,
            valeur: conf.tauxReclamation ?? 0
          },
          delaiTraitement: {
            ...prev.delaiTraitement,
            valeur: delaiTexte
          },
          tauxSatisfaction: {
            ...prev.tauxSatisfaction,
            valeur: conf.tauxSatisfaction ?? 0
          },
          evolutionReclamations: {
            categories: evoCategories,
            series: evoSeries
          },
          repartitionType: baseRepartition
        }));
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des données de conformité:", error);
      // En cas d'erreur, on conserve les valeurs actuelles
    }
  }, [selectedPeriod, dateRange, selectedVille]);

  // Fonction pour récupérer les données de Flotte & Maintenance
  const fetchFlotteMaintenance = useCallback(async () => {
    setLoadingFlotte(true);
    try {
      const params = new URLSearchParams();

      // Ajouter la période
      if (selectedPeriod === 'custom' && dateRange[0] && dateRange[1]) {
        params.append('periode', 'periode');
        params.append('date_debut', formatDate(dateRange[0]));
        params.append('date_fin', formatDate(dateRange[1]));
      } else if (selectedPeriod) {
        params.append('periode', selectedPeriod);
      }

      // Ajouter la ville si sélectionnée
      if (selectedVille && selectedVille !== 'tous') {
        params.append('ville', selectedVille);
      }

      const response = await axios.get(`${config.apiBaseUrl}/analyses/flotte-maintenance?${params.toString()}`);
      const data = response.data;

      if (data) {
        const flotte = data.flotte || {};
        const pannes = data.pannes || {};
        const pannesParVehicule = data.pannesParVehicule || [];

        // Préparer les données du graphique pannes par véhicule
        const vehicules = pannesParVehicule.map(p => p.immatriculation || p.vehicule || '');
        const valeurs = pannesParVehicule.map(p => p.total || p.nombre || 0);
        const couleurs = pannesParVehicule.map((_, index) => {
          const colors = ['#F00013', '#00A9EF', '#FF6800', '#00BC7C', '#CB30E0', '#7239EA', '#F6B100', '#34C759', '#006133', '#656C7A'];
          return colors[index % colors.length];
        });

        setFlotteData({
          vehiculesActifs: {
            valeur: flotte.totalVehicules || flotte.actifs?.total || 0,
            description: 'Flotte opérationnelle'
          },
          pannes: {
            valeur: pannes.total_tasks || 0,
            evolution: 0,
            type: 'pannes'
          },
          entretiens: {
            valeur: flotte.entretiens?.total || 0,
            evolution: 0,
            type: 'entretiens'
          },
          pannesToSoon: { valeur: pannes.total_soon || 0 },
          pannesUrgent: { valeur: pannes.total_urgent || 0 },
          pannesParVehicule: {
            vehicules,
            valeurs,
            couleurs
          },
          repartitionType: {
            reparation: { valeur: 56.7, couleur: '#F8285A' },
            maintenance: { valeur: 25.7, couleur: '#F6B100' },
            gasoil: { valeur: 25.7, couleur: '#34C759' }
          }
        });
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des données de flotte:", error);
    } finally {
      setLoadingFlotte(false);
    }
  }, [selectedPeriod, dateRange, selectedVille]);

  // useEffect pour charger les données des ambulances quand les filtres changent
  useEffect(() => {
    fetchAmbulances();
  }, [fetchAmbulances]);

  // useEffect pour charger les données géographiques quand les filtres changent
  useEffect(() => {
    fetchGeographique();
  }, [fetchGeographique]);



  // useEffect pour charger les données Qualité & Conformité quand les filtres changent
  useEffect(() => {
    fetchQualiteConformite();
  }, [fetchQualiteConformite]);

  // useEffect pour charger les données Flotte & Maintenance quand les filtres changent
  useEffect(() => {
    fetchFlotteMaintenance();
  }, [fetchFlotteMaintenance]);

  // Fonction pour récupérer les données des Médecins Prescripteurs
  const fetchMedecinsPrescripteurs = useCallback(async () => {
    setLoadingMedecins(true);
    try {
      const params = new URLSearchParams();

      // Ajouter la période
      if (selectedPeriod === 'custom' && dateRange[0] && dateRange[1]) {
        params.append('periode', 'periode');
        params.append('date_debut', formatDate(dateRange[0]));
        params.append('date_fin', formatDate(dateRange[1]));
      } else if (selectedPeriod) {
        params.append('periode', selectedPeriod);
      }

      // Ajouter la ville si sélectionnée
      if (selectedVille && selectedVille !== 'tous') {
        params.append('ville', selectedVille);
      }

      const response = await axios.get(`${config.apiBaseUrl}/analyses/medecins-prescripteurs?${params.toString()}`);
      const data = response.data;

      if (data) {
        setMedecinsData({
          medecins: data.medecins || [],
          tauxMissionEnvoyees: data.tauxMissionEnvoyees || [],
          tauxMissionRecues: data.tauxMissionRecues || []
        });
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des données médecins prescripteurs:", error);
    } finally {
      setLoadingMedecins(false);
    }
  }, [selectedPeriod, dateRange, selectedVille]);

  // useEffect pour charger les données Médecins Prescripteurs quand les filtres changent
  useEffect(() => {
    fetchMedecinsPrescripteurs();
  }, [fetchMedecinsPrescripteurs]);

  // Fonction helper pour trouver une spécialité dans les données
  const findSpecialiteInData = (specialites, nom) => {
    if (!specialites || !Array.isArray(specialites)) return { total: 0, pathologies: [] };
    return specialites.find(s =>
      s.nom && s.nom.toLowerCase().includes(nom.toLowerCase())
    ) || { total: 0, pathologies: [] };
  };



 

  // Initialiser Google Maps
  useEffect(() => {
    if (!googleMapsLoaded || !mapRef.current) return;

    if (!mapInstance.current) {
      mapInstance.current = new window.google.maps.Map(mapRef.current, {
        center: { lat: 33.9697284, lng: -6.8703992 }, // Rabat par défaut
        zoom: 10,
        mapTypeId: 'roadmap',
        styles: [
          { "elementType": "geometry", "stylers": [{ "color": "#ebe3cd" }] },
          { "elementType": "labels.text.fill", "stylers": [{ "color": "#523735" }] },
          { "elementType": "labels.text.stroke", "stylers": [{ "color": "#f5f1e6" }] },
          { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#c9b2a6" }] },
          { "featureType": "administrative.land_parcel", "elementType": "geometry.stroke", "stylers": [{ "color": "#dcd2be" }] },
          { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{ "color": "#ae9e90" }] },
          { "featureType": "landscape.natural", "elementType": "geometry", "stylers": [{ "color": "#dfd2ae" }] },
          { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#dfd2ae" }] },
          { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#93817c" }] },
          { "featureType": "poi.park", "elementType": "geometry.fill", "stylers": [{ "color": "#006133" }] },
          { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#447530" }] },
          { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#f5f1e6" }] },
          { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#fdfcf8" }] },
          { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#f8c967" }] },
          { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#e9bc62" }] },
          { "featureType": "road.highway.controlled_access", "elementType": "geometry", "stylers": [{ "color": "#e98d58" }] },
          { "featureType": "road.highway.controlled_access", "elementType": "geometry.stroke", "stylers": [{ "color": "#db8555" }] },
          { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{ "color": "#806b63" }] },
          { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "color": "#dfd2ae" }] },
          { "featureType": "transit.line", "elementType": "labels.text.fill", "stylers": [{ "color": "#8f7d77" }] },
          { "featureType": "transit.line", "elementType": "labels.text.stroke", "stylers": [{ "color": "#ebe3cd" }] },
          { "featureType": "transit.station", "elementType": "geometry", "stylers": [{ "color": "#dfd2ae" }] },
          { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "color": "#b9d3c2" }] },
          { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#92998d" }] }
        ]
      });

      // Écouter les changements de zoom
      mapInstance.current.addListener('zoom_changed', () => {
        const newZoom = mapInstance.current.getZoom();
        setMapZoom(newZoom);
      });

      // Initialiser le zoom
      setMapZoom(mapInstance.current.getZoom());
    }
  }, [googleMapsLoaded]);

  // Fonction pour calculer la distance entre deux points (en degrés)
  const calculateDistance = (lat1, lng1, lat2, lng2) => {
    return Math.sqrt(Math.pow(lat1 - lat2, 2) + Math.pow(lng1 - lng2, 2));
  };

  // Fonction pour regrouper les missions par type et localisation
  const groupMissionsByProximity = (missions, zoomLevel) => {
    // Distance de regroupement adaptative selon le zoom
    // Plus on dézoome, plus la distance augmente (on regroupe plus)
    // À zoom 15+ (détaillé) : ~0.0001 degrés (environ 10m) - très proche
    // À zoom 12 (moyen) : ~0.0005 degrés (environ 50m)
    // À zoom 10 (large) : ~0.001 degrés (environ 100m)
    // À zoom 5 (très large) : ~0.003 degrés (environ 300m)
    const baseDistance = 0.001; // Distance de base à zoom 15 (très proche)
    // Plus on dézoome, plus on augmente la distance de regroupement
    const distance = baseDistance * Math.pow(1.8, Math.max(0, 15 - zoomLevel));

    // Si le zoom est très élevé (>= 14), regrouper les missions avec exactement la même localisation (tous types)
    if (zoomLevel >= 14) {
      const grouped = [];
      const processed = new Set();

      missions.forEach((mission, index) => {
        if (processed.has(index)) return;

        const lat = parseFloat(mission.loc.latitude);
        const lng = parseFloat(mission.loc.longitude);

        // Chercher toutes les missions avec exactement la même localisation (tous types)
        const sameLocationMissions = [mission];
        processed.add(index);

        missions.forEach((otherMission, otherIndex) => {
          if (processed.has(otherIndex) || otherIndex === index) return;

          const otherLat = parseFloat(otherMission.loc.latitude);
          const otherLng = parseFloat(otherMission.loc.longitude);

          // Exactement la même localisation (tolérance très faible)
          if (Math.abs(lat - otherLat) < 0.00001 && Math.abs(lng - otherLng) < 0.00001) {
            sameLocationMissions.push(otherMission);
            processed.add(otherIndex);
          }
        });

        // Calculer les types et leurs proportions
        const typeCounts = {};
        sameLocationMissions.forEach(m => {
          const type = m.type_mission || 'autre';
          typeCounts[type] = (typeCounts[type] || 0) + 1;
        });

        const uniqueTypes = Object.keys(typeCounts);
        const total = sameLocationMissions.length;

        // Si un seul type, utiliser la couleur de ce type
        // Sinon, créer un groupe multi-types
        let displayType = uniqueTypes.length === 1 ? uniqueTypes[0] : 'mixte';
        let displayColor = uniqueTypes.length === 1 ? (typeColors[uniqueTypes[0]] || '#006133') : '#7239EA';

        grouped.push({
          lat: lat,
          lng: lng,
          type: displayType,
          color: displayColor,
          count: total,
          missions: sameLocationMissions,
          types: uniqueTypes,
          typeCounts: typeCounts // Garder les comptes par type pour le cercle divisé
        });
      });

      return grouped;
    }

    // Pour les autres niveaux de zoom, regrouper par type et proximité
    const grouped = [];
    const processed = new Set();

    missions.forEach((mission, index) => {
      if (processed.has(index)) return;

      const lat = parseFloat(mission.loc.latitude);
      const lng = parseFloat(mission.loc.longitude);
      const type = mission.type_mission || 'autre';
      const color = typeColors[type] || '#006133';

      // Chercher les missions proches du MÊME TYPE seulement
      const nearbyMissions = [mission];
      processed.add(index);

      missions.forEach((otherMission, otherIndex) => {
        if (processed.has(otherIndex) || otherIndex === index) return;
        if (otherMission.type_mission !== type) return; // Même type seulement

        const otherLat = parseFloat(otherMission.loc.latitude);
        const otherLng = parseFloat(otherMission.loc.longitude);
        const dist = calculateDistance(lat, lng, otherLat, otherLng);

        // Si la distance est inférieure au seuil, regrouper
        if (dist <= distance) {
          nearbyMissions.push(otherMission);
          processed.add(otherIndex);
        }
      });

      // Calculer la position moyenne du groupe
      const avgLat = nearbyMissions.reduce((sum, m) => sum + parseFloat(m.loc.latitude), 0) / nearbyMissions.length;
      const avgLng = nearbyMissions.reduce((sum, m) => sum + parseFloat(m.loc.longitude), 0) / nearbyMissions.length;

      // Calculer les types et leurs proportions (normalement un seul type ici)
      const typeCounts = {};
      nearbyMissions.forEach(m => {
        const mType = m.type_mission || 'autre';
        typeCounts[mType] = (typeCounts[mType] || 0) + 1;
      });

      const uniqueTypes = Object.keys(typeCounts);

      grouped.push({
        lat: avgLat,
        lng: avgLng,
        type: type,
        color: color,
        count: nearbyMissions.length,
        missions: nearbyMissions,
        types: uniqueTypes,
        typeCounts: typeCounts
      });
    });

    return grouped;
  };

  // Couleurs par type de mission
  const typeColors = {
    'ambulance': '#F6B100',
    'Consultation à domicile': '#006133',
    'acte infirmier': '#F8285A'
  };

  // Fonction pour créer un SVG de cercle divisé en secteurs
  const createDividedCircleIcon = (typeCounts, size = 40) => {
    const total = Object.values(typeCounts).reduce((sum, count) => sum + count, 0);
    const types = Object.keys(typeCounts);
    const radius = size / 2;
    const center = size / 2;

    let currentAngle = -90; // Commencer en haut
    const paths = [];

    types.forEach((type, index) => {
      const count = typeCounts[type];
      const percentage = count / total;
      const angle = percentage * 360;

      const startAngle = currentAngle;
      const endAngle = currentAngle + angle;

      // Convertir les angles en radians
      const startAngleRad = (startAngle * Math.PI) / 180;
      const endAngleRad = (endAngle * Math.PI) / 180;

      // Calculer les points du secteur
      const x1 = center + radius * Math.cos(startAngleRad);
      const y1 = center + radius * Math.sin(startAngleRad);
      const x2 = center + radius * Math.cos(endAngleRad);
      const y2 = center + radius * Math.sin(endAngleRad);

      // Créer le path du secteur
      const largeArcFlag = angle > 180 ? 1 : 0;
      const path = `M ${center} ${center} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;

      paths.push({
        path: path,
        color: typeColors[type] || '#006133'
      });

      currentAngle = endAngle;
    });

    // Créer le SVG
    const svgPaths = paths.map((p, i) =>
      `<path d="${p.path}" fill="${p.color}" stroke="#fff" stroke-width="2"/>`
    ).join('');

    const svg = `
      <svg width="${size}" height="${size}" xmlns="http://www.w3.org/2000/svg">
        ${svgPaths}
      </svg>
    `;

    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
  };

  // Afficher les missions sur la carte
  useEffect(() => {
    if (!googleMapsLoaded || !mapInstance.current || !geographiqueData.missions) return;

    // Supprimer les anciens marqueurs
    markersRef.current.forEach(marker => {
      if (marker) marker.setMap(null);
    });
    markersRef.current = [];

    const validMissions = geographiqueData.missions.filter(mission =>
      mission.loc && mission.loc.latitude && mission.loc.longitude
    );

    if (validMissions.length === 0) return;

    // Regrouper les missions proches
    const groupedMissions = groupMissionsByProximity(validMissions, mapZoom);

    // Créer les marqueurs groupés
    groupedMissions.forEach((group) => {
      // Taille du marqueur adaptative selon le nombre de missions
      const markerSize = group.count === 1 ? 8 : Math.max(20, Math.min(40, 15 + Math.sqrt(group.count) * 3));

      // Déterminer si on doit créer un cercle divisé (plusieurs types à la même localisation)
      const hasMultipleTypes = group.types && group.types.length > 1 && group.typeCounts;

      let iconConfig;

      if (hasMultipleTypes) {
        // Créer un cercle divisé en secteurs
        const iconUrl = createDividedCircleIcon(group.typeCounts, markerSize * 2);
        iconConfig = {
          url: iconUrl,
          scaledSize: new window.google.maps.Size(markerSize * 2, markerSize * 2),
          anchor: new window.google.maps.Point(markerSize, markerSize)
        };
      } else {
        // Cercle simple avec une seule couleur
        iconConfig = {
          path: window.google.maps.SymbolPath.CIRCLE,
          scale: markerSize,
          fillColor: group.color,
          fillOpacity: 0.85,
          strokeColor: '#fff',
          strokeWeight: group.count > 1 ? 3 : 2
        };
      }

      const marker = new window.google.maps.Marker({
        position: { lat: group.lat, lng: group.lng },
        map: mapInstance.current,
        title: `${group.type}: ${group.count} mission(s)`,
        label: group.count > 1 ? {
          text: group.count.toString(),
          color: '#000',
          fontSize: group.count > 9 ? '11px' : '13px',
          fontWeight: 'bold'
        } : undefined,
        icon: iconConfig,
        zIndex: 1000 + group.count
      });

      // InfoWindow pour afficher les détails
      let infoContent = `
        <div style="padding: 10px; font-family: 'Poppins', sans-serif;">
          <h3 style="margin: 0 0 10px 0; color: #171D28; font-size: 14px; font-weight: 600;">
            ${hasMultipleTypes ? 'Missions groupées' : group.type}
          </h3>
          <p style="margin: 0 0 8px 0; color: #656C7A; font-size: 13px;"><strong>Total:</strong> ${group.count} mission(s)</p>
      `;

      // Si plusieurs types, afficher le détail par type
      if (hasMultipleTypes && group.typeCounts) {
        infoContent += '<div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #E5E5E5;">';
        Object.keys(group.typeCounts).forEach(type => {
          const color = typeColors[type] || '#006133';
          const count = group.typeCounts[type];
          infoContent += `
            <p style="margin: 4px 0; color: #656C7A; font-size: 12px;">
              <span style="display: inline-block; width: 10px; height: 10px; background-color: ${color}; border-radius: 50%; margin-right: 6px;"></span>
              ${type}: ${count}
            </p>
          `;
        });
        infoContent += '</div>';
      }

      infoContent += '</div>';

      const infoWindow = new window.google.maps.InfoWindow({
        content: infoContent
      });

      marker.addListener('click', () => {
        // Fermer toutes les autres InfoWindows
        markersRef.current.forEach(m => {
          if (m.infoWindow) m.infoWindow.close();
        });
        infoWindow.open(mapInstance.current, marker);
        marker.infoWindow = infoWindow;
      });

      markersRef.current.push(marker);
    });

    // Ajuster le zoom pour afficher tous les marqueurs (seulement au premier chargement)
    if (validMissions.length > 0 && markersRef.current.length === groupedMissions.length) {
      const bounds = new window.google.maps.LatLngBounds();
      groupedMissions.forEach(group => {
        bounds.extend({ lat: group.lat, lng: group.lng });
      });
      // Ne pas ajuster automatiquement si l'utilisateur a déjà zoomé
      if (mapZoom === 10) {
        mapInstance.current.fitBounds(bounds);
      }
    }
  }, [googleMapsLoaded, geographiqueData.missions, mapZoom]);

  return (
    <Box pt={{ base: "150px", md: "150px", xl: "150px" }}>
      <VStack spacing="20px" align="stretch">

        {/* Bouton Rapport Quotidien Ambulances */}
        {hasPermission('rapport_quotidien_generate') && (
        <Flex justify="flex-end">
          <Button
            bg="#006133"
            color="white"
            borderRadius="8px"
            px="16px"
            h="40px"
            fontSize="14px"
            fontWeight="500"
            fontFamily="Poppins, sans-serif"
            leftIcon={<Icon as={MdFileDownload} w="18px" h="18px" />}
            _hover={{ bg: '#004d27' }}
            onClick={onRapportOpen}
          >
            Générer Rapport Quotidien
          </Button>
        </Flex>
        )}

        {/* Modal rapport quotidien */}
        <Modal isOpen={isRapportOpen} onClose={onRapportClose} isCentered size="md">
          <ModalOverlay />
          <ModalContent borderRadius="12px" fontFamily="Poppins, sans-serif">
            <ModalHeader fontSize="15px" fontWeight="600" color="#171D28" borderBottom="1px solid #E5E5E5" pb="12px">
              Rapport quotidien – Demandes ambulance
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody py="20px">
              <VStack align="stretch" spacing="16px">
                <Box>
                  <Text fontSize="13px" fontWeight="500" color="#171D28" mb="6px">Date du rapport</Text>
                  <Input
                    type="date"
                    value={rapportDate}
                    max={todayStr}
                    onChange={(e) => setRapportDate(e.target.value)}
                    fontSize="13px"
                    borderRadius="8px"
                    borderColor="#E5E5E5"
                    _focus={{ borderColor: '#006133', boxShadow: '0 0 0 1px #006133' }}
                  />
                </Box>
                <Box>
                  <Text fontSize="13px" fontWeight="500" color="#171D28" mb="6px">Filtrer par état</Text>
                  <Select
                    value={rapportEtat}
                    onChange={(e) => setRapportEtat(e.target.value)}
                    fontSize="13px"
                    borderRadius="8px"
                    borderColor="#E5E5E5"
                    _focus={{ borderColor: '#006133', boxShadow: '0 0 0 1px #006133' }}
                  >
                    <option value="tous">Tous (terminées + annulées)</option>
                    <option value="terminée">Terminées uniquement</option>
                    <option value="annulée">Annulées uniquement</option>
                  </Select>
                </Box>
              </VStack>
            </ModalBody>
            <Box px="24px" pb="20px" pt="4px" display="flex" justifyContent="flex-end" gap="10px">
              <Button
                variant="ghost"
                fontSize="13px"
                onClick={onRapportClose}
                isDisabled={rapportLoading}
                borderRadius="8px"
              >
                Annuler
              </Button>
              <Button
                bg="#006133"
                color="white"
                fontSize="13px"
                fontWeight="500"
                borderRadius="8px"
                leftIcon={<Icon as={MdFileDownload} w="16px" h="16px" />}
                isLoading={rapportLoading}
                loadingText="Génération..."
                onClick={handleGenererRapport}
                _hover={{ bg: '#004d27' }}
              >
                Télécharger Excel (.xlsx)
              </Button>
            </Box>
          </ModalContent>
        </Modal>

        {/* Section Activité Opérationnelle - Toujours affichée */}
        {isAnalysisSelected('tous') && (
        <Card
          bg="white"
          border="1px solid"
          borderColor="#E5E5E5"
          borderRadius="12px"
          p="20px"
          boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
        >
          <VStack spacing="20px" align="stretch">
            {/* En-tête avec titre et bouton Générer Rapport */}
            <Flex justify="space-between" align="center" w="100%">
              <Text fontSize="16px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                Activité Opérationnelle
              </Text>

            </Flex>

            {/* Grille de 4 cartes */}
            <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} gap="20px" w="100%">
              {/* Carte 1: Missions totales */}
              <Box
                bg="white"
                border="1px solid"
                borderColor="#E5E5E5"
                borderRadius="12px"
                p="20px"
                boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                w="385px"
              >
                <VStack align="stretch" spacing="10px">
                  <Flex justify="space-between" align="center" w="100%">
                    <Text fontSize="14px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                      Missions totales
                    </Text>
                    <Box
                      w="36px"
                      h="36px"
                      bg="#EFF6FF"
                      border="1px solid"
                      borderColor="rgba(69,156,233,0.2)"
                      borderRadius="6px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Icon as={MdAccessTime} w="18px" h="18px" color="#006133" />
                    </Box>
                  </Flex>
                  <HStack align="end" spacing="10px" w="100%">
                    <Text fontSize="28px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                      {activiteData.missionsTotales.valeur.toLocaleString('fr-FR')}
                    </Text>
                    <Badge
                      bg="#EAF8FA"
                      border="1px solid"
                      borderColor="rgba(41,186,205,0.2)"
                      borderRadius="4px"
                      px="3px"
                      py="3px"
                    >
                      <HStack spacing="5px">
                        <Icon as={MdTrendingUp} w="12px" h="12px" color="#006133" />
                        <Text fontSize="12px" color="#006133" fontWeight="500" fontFamily="Poppins, sans-serif">
                          +{activiteData.missionsTotales.differencePourcentage.toFixed(1)}%
                        </Text>
                      </HStack>
                    </Badge>
                    <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif" flex="1">
                      {getComparisonText(selectedPeriod)}
                    </Text>
                  </HStack>
                  {/* Graphique radial et détails */}
                  <HStack spacing="40px" align="center" py="10px" px="0">
                    <Box w="66px" h="66px" position="relative" flexShrink={0}>
                      {/* Graphique radial dynamique avec SVG */}
                      <svg width="66" height="66" viewBox="0 0 66 66" style={{ transform: 'rotate(-90deg)' }}>
                        <circle
                          cx="33"
                          cy="33"
                          r="25"
                          fill="none"
                          stroke="#006133"
                          strokeWidth="8"
                          strokeDasharray={`${2 * Math.PI * 25}`}
                          strokeDashoffset="0"
                        />
                        {(() => {
                          const total = activiteData.missionsTotalesApplication + activiteData.missionsTotalesTelephone;
                          if (total === 0) return null;
                          const applicationPercentage = (activiteData.missionsTotalesApplication / total) * 100;
                          const circumference = 2 * Math.PI * 25;
                          const offset = circumference - (circumference * applicationPercentage / 100);
                          return (
                            <circle
                              cx="33"
                              cy="33"
                              r="25"
                              fill="none"
                              stroke="#006133"
                              strokeWidth="8"
                              strokeDasharray={`${circumference}`}
                              strokeDashoffset={offset}
                              strokeLinecap="round"
                            />
                          );
                        })()}
                      </svg>
                    </Box>
                    <VStack align="stretch" spacing="10px" flex="1">
                      <Flex justify="space-between" align="center" w="100%">
                        <HStack spacing="10px">
                          <Box w="5px" h="20px" bg="#006133" borderRadius="10px" />
                          <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                            Appels téléphoniques
                          </Text>
                        </HStack>
                        <Text fontSize="18px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                          {activiteData.missionsTotalesTelephone.toLocaleString('fr-FR')}
                        </Text>
                      </Flex>
                      <Flex justify="space-between" align="center" w="100%">
                        <HStack spacing="10px">
                          <Box w="5px" h="20px" bg="#006133" borderRadius="10px" />
                          <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                            Application
                          </Text>
                        </HStack>
                        <Text fontSize="18px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                          {activiteData.missionsTotalesApplication.toLocaleString('fr-FR')}
                        </Text>
                      </Flex>
                    </VStack>
                  </HStack>
                </VStack>
              </Box>

              {/* Carte 2: Missions urgentes */}
              <Box
                bg="white"
                border="1px solid"
                borderColor="#E5E5E5"
                borderRadius="12px"
                p="20px"
                boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                flex="1"
              >
                <VStack align="stretch" spacing="10px">
                  <Flex justify="space-between" align="center" w="100%">
                    <Text fontSize="14px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                      Missions urgentes
                    </Text>
                    <Box
                      w="36px"
                      h="36px"
                      bg="#FFEEF3"
                      border="1px solid"
                      borderColor="rgba(248,40,90,0.2)"
                      borderRadius="6px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Icon as={MdShowChart} w="20px" h="20px" color="#F8285A" />
                    </Box>
                  </Flex>
                  <HStack align="end" spacing="10px" w="100%">
                    <Text fontSize="28px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                      {activiteData.missionsUrgentes.valeur}
                    </Text>
                    <Flex flex="1" align="center">
                      <HStack spacing="10px" flex="1">
                        <Badge
                          bg="#EAF8FA"
                          border="1px solid"
                          borderColor="rgba(41,186,205,0.2)"
                          borderRadius="4px"
                          px="3px"
                          py="3px"
                        >
                          <HStack spacing="5px">
                            <Icon as={MdTrendingUp} w="12px" h="12px" color="#006133" />
                            <Text fontSize="12px" color="#006133" fontWeight="500" fontFamily="Poppins, sans-serif">
                              +{activiteData.missionsUrgentes.differencePourcentage.toFixed(1)}%
                            </Text>
                          </HStack>
                        </Badge>
                        <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif" flex="1">
                          {getComparisonText(selectedPeriod)}
                        </Text>
                      </HStack>
                    </Flex>
                  </HStack>
                  {/* Graphique radial et détails */}
                  <HStack spacing="40px" align="center" py="10px" px="0">
                    <Box w="66px" h="66px" position="relative" flexShrink={0}>
                      {/* Graphique radial dynamique avec SVG */}
                      <svg width="66" height="66" viewBox="0 0 66 66" style={{ transform: 'rotate(-90deg)' }}>
                        <circle
                          cx="33"
                          cy="33"
                          r="25"
                          fill="none"
                          stroke="#006133"
                          strokeWidth="8"
                          strokeDasharray={`${2 * Math.PI * 25}`}
                          strokeDashoffset="0"
                        />
                        {(() => {
                          const total = activiteData.missionsUrgentesApplication + activiteData.missionsUrgentesTelephone;
                          if (total === 0) return null;
                          const applicationPercentage = (activiteData.missionsUrgentesApplication / total) * 100;
                          const circumference = 2 * Math.PI * 25;
                          const offset = circumference - (circumference * applicationPercentage / 100);
                          return (
                            <circle
                              cx="33"
                              cy="33"
                              r="25"
                              fill="none"
                              stroke="#006133"
                              strokeWidth="8"
                              strokeDasharray={`${circumference}`}
                              strokeDashoffset={offset}
                              strokeLinecap="round"
                            />
                          );
                        })()}
                      </svg>
                    </Box>
                    <VStack align="stretch" spacing="10px" flex="1">
                      <Flex justify="space-between" align="center" w="100%">
                        <HStack spacing="10px">
                          <Box w="5px" h="20px" bg="#006133" borderRadius="10px" />
                          <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                            Appels téléphoniques
                          </Text>
                        </HStack>
                        <Text fontSize="18px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                          {activiteData.missionsUrgentesTelephone.toLocaleString('fr-FR')}
                        </Text>
                      </Flex>
                      <Flex justify="space-between" align="center" w="100%">
                        <HStack spacing="10px">
                          <Box w="5px" h="20px" bg="#006133" borderRadius="10px" />
                          <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                            Application
                          </Text>
                        </HStack>
                        <Text fontSize="18px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                          {activiteData.missionsUrgentesApplication.toLocaleString('fr-FR')}
                        </Text>
                      </Flex>
                    </VStack>
                  </HStack>
                </VStack>
              </Box>

              {/* Carte 3: Missions planifiées */}
              <Box
                bg="white"
                border="1px solid"
                borderColor="#E5E5E5"
                borderRadius="12px"
                p="20px"
                boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                flex="1"
              >
                <VStack align="stretch" spacing="10px">
                  <Flex justify="space-between" align="center" w="100%">
                    <Text fontSize="14px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                      Missions planifiées
                    </Text>
                    <Box
                      w="36px"
                      h="36px"
                      bg="#FFF8DD"
                      border="1px solid"
                      borderColor="rgba(246,177,0,0.2)"
                      borderRadius="6px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Icon as={MdCalendarToday} w="20px" h="20px" color="#F6B100" />
                    </Box>
                  </Flex>
                  <HStack align="end" spacing="10px" w="100%">
                    <Text fontSize="28px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                      {activiteData.missionsPlanifiees.valeur.toLocaleString('fr-FR')}
                    </Text>
                    <Flex flex="1" align="center">
                      <HStack spacing="10px" flex="1">
                        <Badge
                          bg="#EAF8FA"
                          border="1px solid"
                          borderColor="rgba(41,186,205,0.2)"
                          borderRadius="4px"
                          px="3px"
                          py="3px"
                        >
                          <HStack spacing="5px">
                            <Icon as={MdTrendingUp} w="12px" h="12px" color="#006133" />
                            <Text fontSize="12px" color="#006133" fontWeight="500" fontFamily="Poppins, sans-serif">
                              +{activiteData.missionsPlanifiees.differencePourcentage.toFixed(1)}%
                            </Text>
                          </HStack>
                        </Badge>
                        <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif" flex="1">
                          {getComparisonText(selectedPeriod)}
                        </Text>
                      </HStack>
                    </Flex>
                  </HStack>
                  {/* Graphique radial et détails */}
                  <HStack spacing="40px" align="center" py="10px" px="0">
                    <Box w="66px" h="66px" position="relative" flexShrink={0}>
                      {/* Graphique radial dynamique avec SVG */}
                      <svg width="66" height="66" viewBox="0 0 66 66" style={{ transform: 'rotate(-90deg)' }}>
                        <circle
                          cx="33"
                          cy="33"
                          r="25"
                          fill="none"
                          stroke="#006133"
                          strokeWidth="8"
                          strokeDasharray={`${2 * Math.PI * 25}`}
                          strokeDashoffset="0"
                        />
                        {(() => {
                          const total = activiteData.missionsPlanifieesApplication + activiteData.missionsPlanifieesTelephone;
                          if (total === 0) return null;
                          const applicationPercentage = (activiteData.missionsPlanifieesApplication / total) * 100;
                          const circumference = 2 * Math.PI * 25;
                          const offset = circumference - (circumference * applicationPercentage / 100);
                          return (
                            <circle
                              cx="33"
                              cy="33"
                              r="25"
                              fill="none"
                              stroke="#006133"
                              strokeWidth="8"
                              strokeDasharray={`${circumference}`}
                              strokeDashoffset={offset}
                              strokeLinecap="round"
                            />
                          );
                        })()}
                      </svg>
                    </Box>
                    <VStack align="stretch" spacing="10px" flex="1">
                      <Flex justify="space-between" align="center" w="100%">
                        <HStack spacing="10px">
                          <Box w="5px" h="20px" bg="#006133" borderRadius="10px" />
                          <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                            Appels téléphoniques
                          </Text>
                        </HStack>
                        <Text fontSize="18px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                          {activiteData.missionsPlanifieesTelephone.toLocaleString('fr-FR')}
                        </Text>
                      </Flex>
                      <Flex justify="space-between" align="center" w="100%">
                        <HStack spacing="10px">
                          <Box w="5px" h="20px" bg="#006133" borderRadius="10px" />
                          <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                            Application
                          </Text>
                        </HStack>
                        <Text fontSize="18px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                          {activiteData.missionsPlanifieesApplication.toLocaleString('fr-FR')}
                        </Text>
                      </Flex>
                    </VStack>
                  </HStack>
                </VStack>
              </Box>

              {/* Carte 4: Taux de performance */}
              <Box
                bg="white"
                border="1px solid"
                borderColor="#E5E5E5"
                borderRadius="12px"
                p="20px"
                boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                flex="1"
              >
                <VStack align="stretch" spacing="10px">
                  <Flex justify="space-between" align="center" w="100%">
                    <Text fontSize="14px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                      Taux de performance
                    </Text>
                    <Box
                      w="36px"
                      h="36px"
                      bg="#EAF8FA"
                      border="1px solid"
                      borderColor="rgba(41,186,205,0.2)"
                      borderRadius="6px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Icon as={MdShield} w="20px" h="20px" color="#006133" />
                    </Box>
                  </Flex>
                  <Text fontSize="28px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                    {activiteData.tauxPerformance.valeur}%
                  </Text>
                  <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                    Missions terminées
                  </Text>
                  <HStack spacing="10px" align="center" w="100%">
                    <Badge
                      bg="#EAF8FA"
                      border="1px solid"
                      borderColor="rgba(41,186,205,0.2)"
                      borderRadius="4px"
                      px="3px"
                      py="3px"
                    >
                      <HStack spacing="5px">
                        <Icon as={MdTrendingUp} w="12px" h="12px" color="#006133" />
                        <Text fontSize="12px" color="#006133" fontWeight="500" fontFamily="Poppins, sans-serif">
                          +{activiteData.tauxPerformance.differencePourcentage.toFixed(1)}%
                        </Text>
                      </HStack>
                    </Badge>
                    <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif" flex="1">
                      {getComparisonText(selectedPeriod)}
                    </Text>
                  </HStack>
                </VStack>
              </Box>
            </SimpleGrid>
          </VStack>
        </Card>
        )}

        {/* Section 2: Missions - Métriques de délais */}
        {isAnalysisSelected('missions') && (
        <Card
          bg="white"
          border="1px solid"
          borderColor="#E5E5E5"
          borderRadius="12px"
          p="20px"
          boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
          mb="30px"
        >
          <VStack align="stretch" spacing="20px">
            <Flex justify="space-between" align="center">
              <Text fontSize="16px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                Missions
              </Text>
              <HStack spacing="10px">
                <HStack
                  bg="#F9F9F9"
                  border="1px solid"
                  borderColor="#E5E5E5"
                  borderRadius="8px"
                  p="3px"
                  spacing="5px"
                >
                  <Button
                    onClick={() => setMissionFilter('tous')}
                    bg={missionFilter === 'tous' ? '#006133' : 'transparent'}
                    color={missionFilter === 'tous' ? 'white' : '#171D28'}
                    borderRadius="6px"
                    h="30px"
                    px="10px"
                    py="3px"
                    fontSize="14px"
                    fontWeight="500"
                    fontFamily="Poppins, sans-serif"
                    boxShadow={missionFilter === 'tous' ? '0px 3px 4px 0px rgba(0,0,0,0.03)' : 'none'}
                    _hover={{ bg: missionFilter === 'tous' ? '#006133' : 'transparent' }}
                  >
                    Ambulances
                  </Button>

                </HStack>

              </HStack>
            </Flex>

            <SimpleGrid columns={{ base: 1, md: 2, xl: 4 }} gap="14px">
              {/* Délai 1: Durée Totale Moyenne */}
              <Box
                bg="white"
                border="1px solid"
                borderColor="#E5E5E5"
                borderRadius="12px"
                p="20px"
                pt="14px"
                boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
              >
                <VStack align="stretch" spacing="10px">
                  <Flex justify="space-between" align="start" w="100%">
                    <VStack align="start" spacing="10px" flex="1">
                      <Box
                        w="36px"
                        h="36px"
                        bg="#EFF6FF"
                        border="1px solid"
                        borderColor="rgba(69,156,233,0.2)"
                        borderRadius="6px"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Icon as={MdTimer} w="20px" h="20px" color="#006133" />
                      </Box>
                      <Text fontSize="14px" color="#656C7A" fontWeight="400" fontFamily="Poppins, sans-serif">
                        Durée Totale Moyenne Mission
                      </Text>
                    </VStack>
                    <Badge
                      bg="#FFEEF3"
                      border="1px solid"
                      borderColor="rgba(248,40,90,0.2)"
                      borderRadius="30px"
                      px="10px"
                      py="5px"
                      display="flex"
                      alignItems="center"
                      gap="5px"
                    >
                      <Box w="6px" h="6px" bg="#F8285A" borderRadius="50%" />
                      <Text fontSize="13px" color="#F8285A" fontWeight="500" fontFamily="Poppins, sans-serif">
                        LIVE
                      </Text>
                    </Badge>
                  </Flex>
                  <HStack align="end" spacing="10px">
                    <Text fontSize="28px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                      {minutesToMMSS(missionsData.dureeTotaleMoyenne.valeur)}
                    </Text>
                    <Badge
                      bg="#EAF8FA"
                      border="1px solid"
                      borderColor="rgba(41,186,205,0.2)"
                      borderRadius="4px"
                      px="3px"
                      py="3px"
                      display="flex"
                      alignItems="center"
                      gap="5px"
                    >
                      <Icon as={MdArrowDownward} w="12px" h="12px" color="#006133" />
                      <Text fontSize="12px" color="#006133" fontWeight="500" fontFamily="Poppins, sans-serif">
                        -12% vs mois
                      </Text>
                    </Badge>
                  </HStack>
                </VStack>
              </Box>

              {/* Délai 2: Délai Moyen Intervention */}
              <Box
                bg="white"
                border="1px solid"
                borderColor="#E5E5E5"
                borderRadius="12px"
                p="20px"
                pt="14px"
                boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
              >
                <VStack align="stretch" spacing="10px">
                  <Flex justify="space-between" align="start" w="100%">
                    <VStack align="start" spacing="10px" flex="1">
                      <Box
                        w="36px"
                        h="36px"
                        bg="#EFF6FF"
                        border="1px solid"
                        borderColor="rgba(69,156,233,0.2)"
                        borderRadius="6px"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Icon as={MdAccessTime} w="20px" h="20px" color="#006133" />
                      </Box>
                      <Text fontSize="14px" color="#656C7A" fontWeight="400" fontFamily="Poppins, sans-serif">
                        Délai Moyen Intervention
                      </Text>
                      <Text fontSize="28px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                        {minutesToMMSS(missionsData.delaiIntervention.valeur)}
                      </Text>
                    </VStack>
                    <Badge
                      bg="#FFEEF3"
                      border="1px solid"
                      borderColor="rgba(248,40,90,0.2)"
                      borderRadius="30px"
                      px="10px"
                      py="5px"
                      display="flex"
                      alignItems="center"
                      gap="5px"
                    >
                      <Box w="6px" h="6px" bg="#F8285A" borderRadius="50%" />
                      <Text fontSize="13px" color="#F8285A" fontWeight="500" fontFamily="Poppins, sans-serif">
                        LIVE
                      </Text>
                    </Badge>
                  </Flex>
                  <HStack spacing="10px" align="center">
                    <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                      Depuis 00:00 AM
                    </Text>
                    <Badge
                      bg="#EAF8FA"
                      border="1px solid"
                      borderColor="rgba(41,186,205,0.2)"
                      borderRadius="4px"
                      px="3px"
                      py="3px"
                      display="flex"
                      alignItems="center"
                      gap="5px"
                    >
                      <Icon as={MdArrowDownward} w="12px" h="12px" color="#006133" />
                      <Text fontSize="12px" color="#006133" fontWeight="500" fontFamily="Poppins, sans-serif">
                        -12% vs mois
                      </Text>
                    </Badge>
                  </HStack>
                </VStack>
              </Box>

              {/* Délai 3: Délai Moyen d'Affectation */}
              <Box
                bg="white"
                border="1px solid"
                borderColor="#E5E5E5"
                borderRadius="12px"
                p="20px"
                pt="14px"
                boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
              >
                <VStack align="stretch" spacing="10px">
                  <VStack align="start" spacing="10px" flex="1">
                    <Box
                      w="36px"
                      h="36px"
                      bg="#EFF6FF"
                      border="1px solid"
                      borderColor="rgba(69,156,233,0.2)"
                      borderRadius="6px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Icon as={MdTimer} w="20px" h="20px" color="#006133" />
                    </Box>
                    <Text fontSize="14px" color="#656C7A" fontWeight="400" fontFamily="Poppins, sans-serif">
                      Délai Moyen d'Affectation
                    </Text>
                    <Text fontSize="28px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                      {minutesToMMSS(missionsData.delaiAffectation.valeur)}
                    </Text>
                  </VStack>
                  <HStack spacing="10px" align="center">
                    <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                      Depuis 00:00 AM
                    </Text>
                    <Badge
                      bg="#EAF8FA"
                      border="1px solid"
                      borderColor="rgba(41,186,205,0.2)"
                      borderRadius="4px"
                      px="3px"
                      py="3px"
                      display="flex"
                      alignItems="center"
                      gap="5px"
                    >
                      <Icon as={MdArrowDownward} w="12px" h="12px" color="#006133" />
                      <Text fontSize="12px" color="#006133" fontWeight="500" fontFamily="Poppins, sans-serif">
                        -12% vs mois
                      </Text>
                    </Badge>
                  </HStack>
                </VStack>
              </Box>

              {/* Délai 4: Délai Moyen sur site */}
              <Box
                bg="white"
                border="1px solid"
                borderColor="#E5E5E5"
                borderRadius="12px"
                p="20px"
                pt="14px"
                boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
              >
                <VStack align="stretch" spacing="10px">
                  <VStack align="start" spacing="10px" flex="1">
                    <Box
                      w="36px"
                      h="36px"
                      bg="#FFF8DD"
                      border="1px solid"
                      borderColor="rgba(246,177,0,0.2)"
                      borderRadius="6px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Icon as={MdAccessTime} w="18px" h="18px" color="#F6B100" />
                    </Box>
                    <Text fontSize="14px" color="#656C7A" fontWeight="400" fontFamily="Poppins, sans-serif">
                      Délai Moyen sur site
                    </Text>
                    <Text fontSize="28px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                      {minutesToMMSS(missionsData.delaiSurSite.valeur)}
                    </Text>
                  </VStack>
                  <HStack spacing="10px" align="center">
                    <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                      Depuis 00:00 AM
                    </Text>
                    <Badge
                      bg="#EAF8FA"
                      border="1px solid"
                      borderColor="rgba(41,186,205,0.2)"
                      borderRadius="4px"
                      px="3px"
                      py="3px"
                      display="flex"
                      alignItems="center"
                      gap="5px"
                    >
                      <Icon as={MdArrowDownward} w="12px" h="12px" color="#006133" />
                      <Text fontSize="12px" color="#006133" fontWeight="500" fontFamily="Poppins, sans-serif">
                        -12% vs mois
                      </Text>
                    </Badge>
                  </HStack>
                </VStack>
              </Box>
            </SimpleGrid>
          </VStack>
        </Card>
        )}

        {/* Section 3: Analyse des ambulances */}
        {isAnalysisSelected('ambulances') && (
        <Card
          bg="white"
          border="1px solid"
          borderColor="#E5E5E5"
          borderRadius="12px"
          p="20px"
          boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
          mb="30px"
        >
          <VStack align="stretch" spacing="20px">
            <Flex justify="space-between" align="center">
              <Text fontSize="14px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                Analyse des ambulances
              </Text>

            </Flex>

            <Flex gap="20px" direction={{ base: "column", lg: "row" }}>
              {/* Graphique en barres - Nombre total de missions / Ambulance */}
              <Box
                border="1px solid"
                borderColor="#E5E5E5"
                borderRadius="12px"
                p="20px"
                boxShadow="0px 3px 20px 0px rgba(0,0,0,0.06)"
                flex="1"
                minW="0"
              >
                <VStack align="stretch" spacing="40px">
                  <Text fontSize="14px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                    Nombre total de missions / Ambulance
                  </Text>
                  <Box h="367px">
                    <Chart
                      type="bar"
                      height={367}
                      series={[{
                        name: 'Missions',
                        data: ambulancesData.missionsParAmbulance.length > 0 ? ambulancesData.missionsParAmbulance : [0]
                      }]}
                      options={{
                        chart: {
                          type: 'bar',
                          toolbar: { show: false },
                          fontFamily: 'Poppins, sans-serif'
                        },
                        plotOptions: {
                          bar: {
                            borderRadius: 4,
                            columnWidth: '24px',
                            distributed: true
                          }
                        },
                        colors: ambulancesData.missionsParAmbulance.map(value =>
                          value <= 20 ? '#00A9EF' : value <= 25 ? '#00B9D9' : value <= 30 ? '#0087CD' : '#006CA7'
                        ),
                        dataLabels: {
                          enabled: true,
                          style: {
                            fontSize: '14px',
                            fontWeight: 600,
                            fontFamily: 'Poppins, sans-serif',
                            colors: ['#171D28']
                          },
                          offsetY: -5
                        },
                        xaxis: {
                          categories: ambulancesData.categories.length > 0 ? ambulancesData.categories : ['AMB-001', 'AMB-002', 'AMB-003', 'AMB-004', 'AMB-005', 'AMB-006', 'AMB-007', 'AMB-008', 'AMB-009', 'AMB-010'],
                          labels: {
                            style: {
                              fontSize: '13px',
                              fontWeight: 500,
                              fontFamily: 'Poppins, sans-serif',
                              colors: '#171D28'
                            }
                          }
                        },
                        yaxis: {
                          show: false
                        },
                        grid: {
                          show: true,
                          borderColor: '#E5E5E5',
                          strokeDashArray: 0,
                          xaxis: {
                            lines: {
                              show: false
                            }
                          },
                          yaxis: {
                            lines: {
                              show: true
                            }
                          }
                        },
                        tooltip: {
                          enabled: false
                        },
                        legend: {
                          show: false
                        }
                      }}
                    />
                  </Box>
                </VStack>
              </Box>
            </Flex>
          </VStack>
        </Card>
        )}

        {/* Section 4: Mode de transport, Type de missions, Taux de gravité */}
        {isAnalysisSelected('missions') && (
        <SimpleGrid columns={{ base: 1, md: 3 }} gap="20px" mb="30px">
          {/* Mode de transport */}
          <Card
            bg="white"
            border="1px solid"
            borderColor="#E5E5E5"
            borderRadius="12px"
            p="20px"
            boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
          >
            <VStack align="stretch" spacing="10px">
              <Text fontSize="14px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                Mode de transport
              </Text>
              <Flex justify="center" align="center" h="160px" gap="40px">
                <Box position="relative" w="160px" h="115px">
                  <Chart
                    type="donut"
                    height={160}
                    series={ambulancesData.typeAmbulances.length > 0 ? ambulancesData.typeAmbulances.map(ta => ta.total) : [0, 0, 0]}
                    options={{
                      chart: {
                        type: 'donut',
                        fontFamily: 'Poppins, sans-serif'
                      },
                      labels: ambulancesData.typeAmbulances.length > 0 ? ambulancesData.typeAmbulances.map(ta => ta.type) : ['Réanimation', 'Simple'],
                      colors: ['#F8285A', '#006133', '#F6B100'],
                      plotOptions: {
                        pie: {
                          donut: {
                            size: '70%',
                            labels: {
                              show: false
                            }
                          }
                        }
                      },
                      dataLabels: {
                        enabled: false
                      },
                      legend: {
                        show: false
                      },
                      tooltip: {
                        enabled: false
                      }
                    }}
                  />
                  <Box
                    position="absolute"
                    top="50%"
                    left="50%"
                    transform="translate(-50%, -50%)"
                    textAlign="center"
                  >
                    <Text fontSize="28px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                      {ambulancesData.typeAmbulances.reduce((sum, ta) => sum + (ta.total || 0), 0)}
                    </Text>
                    <Text fontSize="14px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                      Total
                    </Text>
                  </Box>
                </Box>
                <VStack align="stretch" spacing="5px" flex="1">
                  {ambulancesData.typeAmbulances.length > 0 ? ambulancesData.typeAmbulances.map((ta, index) => {
                    const colors = ['#F8285A', '#006133', '#F6B100'];
                    return (
                      <HStack key={index} justify="space-between">
                        <HStack spacing="5px">
                          <Box w="9px" h="20px" bg={colors[index % colors.length]} borderRadius="10px" />
                          <Text fontSize="13px" color="#171D28" fontWeight="400" fontFamily="Poppins, sans-serif">
                            {ta.type}
                          </Text>
                        </HStack>
                        <Text fontSize="13px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                          {ta.total} ({ta.pourcentage ? ta.pourcentage.toFixed(1) : 0}%)
                        </Text>
                      </HStack>
                    );
                  }) : (
                    <>
                      <HStack justify="space-between">
                        <HStack spacing="5px">
                          <Box w="9px" h="20px" bg="#F8285A" borderRadius="10px" />
                          <Text fontSize="13px" color="#171D28" fontWeight="400" fontFamily="Poppins, sans-serif">
                            Aucune donnée
                          </Text>
                        </HStack>
                        <Text fontSize="13px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                          0 (0%)
                        </Text>
                      </HStack>
                    </>
                  )}
                </VStack>
              </Flex>
            </VStack>
          </Card>

          {/* Type de missions */}
          <Card
            bg="white"
            border="1px solid"
            borderColor="#E5E5E5"
            borderRadius="12px"
            p="20px"
            boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
          >
            <VStack align="stretch" spacing="10px">
              <Text fontSize="14px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                Type de missions
              </Text>
              <Flex justify="center" align="center" h="160px" gap="40px">
                <Box position="relative" w="160px" h="115px">
                  <Chart
                    type="donut"
                    height={160}
                    series={ambulancesData.typeMissions.length > 0 ? ambulancesData.typeMissions.map(tm => tm.total) : [0, 0]}
                    options={{
                      chart: {
                        type: 'donut',
                        fontFamily: 'Poppins, sans-serif'
                      },
                      labels: ambulancesData.typeMissions.length > 0 ? ambulancesData.typeMissions.map(tm => tm.etat_mission) : ['Terminées', 'En cours'],
                      colors: ['#F8285A', '#006133', '#F6B100', '#006133'],
                      plotOptions: {
                        pie: {
                          donut: {
                            size: '70%',
                            labels: {
                              show: false
                            }
                          }
                        }
                      },
                      dataLabels: {
                        enabled: false
                      },
                      legend: {
                        show: false
                      },
                      tooltip: {
                        enabled: false
                      }
                    }}
                  />
                  <Box
                    position="absolute"
                    top="50%"
                    left="50%"
                    transform="translate(-50%, -50%)"
                    textAlign="center"
                  >
                    <Text fontSize="28px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                      {ambulancesData.typeMissions.reduce((sum, tm) => sum + (tm.total || 0), 0)}
                    </Text>
                    <Text fontSize="14px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                      Total
                    </Text>
                  </Box>
                </Box>
                <VStack align="stretch" spacing="5px" flex="1">
                  {ambulancesData.typeMissions.length > 0 ? ambulancesData.typeMissions.map((tm, index) => {
                    const colors = ['#F8285A', '#006133', '#F6B100', '#006133'];
                    return (
                      <HStack key={index} justify="space-between">
                        <HStack spacing="5px">
                          <Box w="9px" h="20px" bg={colors[index % colors.length]} borderRadius="10px" />
                          <Text fontSize="13px" color="#171D28" fontWeight="400" fontFamily="Poppins, sans-serif">
                            {tm.etat_mission}
                          </Text>
                        </HStack>
                        <Text fontSize="13px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                          {tm.total} ({tm.pourcentage ? tm.pourcentage.toFixed(1) : 0}%)
                        </Text>
                      </HStack>
                    );
                  }) : (
                    <>
                      <HStack justify="space-between">
                        <HStack spacing="5px">
                          <Box w="9px" h="20px" bg="#F8285A" borderRadius="10px" />
                          <Text fontSize="13px" color="#171D28" fontWeight="400" fontFamily="Poppins, sans-serif">
                            Aucune donnée
                          </Text>
                        </HStack>
                        <Text fontSize="13px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                          0 (0%)
                        </Text>
                      </HStack>
                    </>
                  )}
                </VStack>
              </Flex>
            </VStack>
          </Card>

          {/* Taux de gravité */}
          <Card
            bg="white"
            border="1px solid"
            borderColor="#E5E5E5"
            borderRadius="12px"
            p="20px"
            boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
          >
            <VStack align="stretch" spacing="10px">
              <Text fontSize="14px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                Taux de gravité
              </Text>
              <Flex justify="center" align="center" h="160px" gap="40px">
                <Box position="relative" w="160px" h="115px">
                  <Chart
                    type="donut"
                    height={160}
                    series={ambulancesData.tauxGravite.length > 0 ? ambulancesData.tauxGravite.map(tg => tg.total) : [0, 0, 0]}
                    options={{
                      chart: {
                        type: 'donut',
                        fontFamily: 'Poppins, sans-serif'
                      },
                      labels: ambulancesData.tauxGravite.length > 0 ? ambulancesData.tauxGravite.map(tg => tg.categorie) : ['Urgence Vitale', 'Urgence Élevée', 'Non Vitale'],
                      colors: ['#F8285A', '#F6B100', '#006133'],
                      plotOptions: {
                        pie: {
                          donut: {
                            size: '70%',
                            labels: {
                              show: false
                            }
                          }
                        }
                      },
                      dataLabels: {
                        enabled: false
                      },
                      legend: {
                        show: false
                      },
                      tooltip: {
                        enabled: false
                      }
                    }}
                  />
                  <Box
                    position="absolute"
                    top="50%"
                    left="50%"
                    transform="translate(-50%, -50%)"
                    textAlign="center"
                  >
                    <Text fontSize="28px" color="#171D28" fontWeight="600" fontFamily="Oswald, sans-serif">
                      {ambulancesData.tauxGravite.reduce((sum, tg) => sum + (tg.total || 0), 0)}
                    </Text>
                    <Text fontSize="14px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                      Total
                    </Text>
                  </Box>
                </Box>
                <VStack align="stretch" spacing="5px" flex="1">
                  {ambulancesData.tauxGravite.length > 0 ? ambulancesData.tauxGravite.map((tg, index) => {
                    const colors = ['#F8285A', '#F6B100', '#006133'];
                    return (
                      <HStack key={index} justify="space-between">
                        <HStack spacing="5px">
                          <Box w="9px" h="20px" bg={colors[index % colors.length]} borderRadius="10px" />
                          <Text fontSize="13px" color="#171D28" fontWeight="400" fontFamily="Poppins, sans-serif">
                            {tg.categorie}
                          </Text>
                        </HStack>
                        <Text fontSize="13px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                          {tg.total} ({tg.pourcentage ? tg.pourcentage.toFixed(1) : 0}%)
                        </Text>
                      </HStack>
                    );
                  }) : (
                    <>
                      <HStack justify="space-between">
                        <HStack spacing="5px">
                          <Box w="9px" h="20px" bg="#F8285A" borderRadius="10px" />
                          <Text fontSize="13px" color="#171D28" fontWeight="400" fontFamily="Poppins, sans-serif">
                            Aucune donnée
                          </Text>
                        </HStack>
                        <Text fontSize="13px" color="#171D28" fontWeight="500" fontFamily="Poppins, sans-serif">
                          0 (0%)
                        </Text>
                      </HStack>
                    </>
                  )}
                </VStack>
              </Flex>
            </VStack>
          </Card>
        </SimpleGrid>
        )}

        {/* Section 4.5: Performance */}
        {isAnalysisSelected('performance') && (
         <Card bg={cardBg} p="20px" borderRadius="12px" mb="30px">
         <VStack align="stretch" spacing="20px">
           {/* Header avec titre, filtres et bouton rapport */}
           <Flex justify="space-between" align="center" wrap="wrap" gap="10px">
             <Heading fontSize="16px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
               Performance
             </Heading>
             <HStack spacing="10px" flex="1" justify="flex-end">
               {/* Boutons de filtre */}
               <Box
                 bg="#F9F9F9"
                 border="1px solid #E5E5E5"
                 borderRadius="8px"
                 p="3px"
                 display="flex"
                 gap="5px"
               >
                 <Button
                   size="sm"
                   h="30px"
                   px="10px"
                   py="2px"
                   borderRadius="8px"
                   bg={performanceFilter === 'ambulancier' ? '#006133' : 'transparent'}
                   color={performanceFilter === 'ambulancier' ? 'white' : '#171D28'}
                   fontSize="14px"
                   fontWeight="500"
                   fontFamily="Poppins, sans-serif"
                   boxShadow={performanceFilter === 'ambulancier' ? '0px 3px 4px 0px rgba(0,0,0,0.03)' : 'none'}
                   onClick={() => setPerformanceFilter('ambulancier')}
                   _hover={{ bg: performanceFilter === 'ambulancier' ? '#006133' : 'transparent' }}
                 >
                   Ambulancier
                 </Button>
                 <Button
                   size="sm"
                   h="30px"
                   px="10px"
                   py="2px"
                   borderRadius="8px"
                   bg={performanceFilter === 'medecin' ? '#006133' : 'transparent'}
                   color={performanceFilter === 'medecin' ? 'white' : '#171D28'}
                   fontSize="14px"
                   fontWeight="500"
                   fontFamily="Poppins, sans-serif"
                   boxShadow={performanceFilter === 'medecin' ? '0px 3px 4px 0px rgba(0,0,0,0.03)' : 'none'}
                   onClick={() => setPerformanceFilter('medecin')}
                   _hover={{ bg: performanceFilter === 'medecin' ? '#006133' : 'transparent' }}
                 >
                   Médecin
                 </Button>
                 <Button
                   size="sm"
                   h="30px"
                   px="10px"
                   py="2px"
                   borderRadius="8px"
                   bg={performanceFilter === 'infirmier' ? '#006133' : 'transparent'}
                   color={performanceFilter === 'infirmier' ? 'white' : '#171D28'}
                   fontSize="14px"
                   fontWeight="500"
                   fontFamily="Poppins, sans-serif"
                   boxShadow={performanceFilter === 'infirmier' ? '0px 3px 4px 0px rgba(0,0,0,0.03)' : 'none'}
                   onClick={() => setPerformanceFilter('infirmier')}
                   _hover={{ bg: performanceFilter === 'infirmier' ? '#006133' : 'transparent' }}
                 >
                   Infirmier
                 </Button>
                 <Button
                   size="sm"
                   h="30px"
                   px="10px"
                   py="2px"
                   borderRadius="8px"
                   bg={performanceFilter === 'regulateur' ? '#006133' : 'transparent'}
                   color={performanceFilter === 'regulateur' ? 'white' : '#171D28'}
                   fontSize="14px"
                   fontWeight="500"
                   fontFamily="Poppins, sans-serif"
                   boxShadow={performanceFilter === 'regulateur' ? '0px 3px 4px 0px rgba(0,0,0,0.03)' : 'none'}
                   onClick={() => setPerformanceFilter('regulateur')}
                   _hover={{ bg: performanceFilter === 'regulateur' ? '#006133' : 'transparent' }}
                 >
                   Régulateur
                 </Button>
               </Box>
               {/* Bouton Générer Rapport */}
               <Button
                 bg="#FCFCFC"
                 border="1px solid #DBDFE9"
                 borderRadius="6px"
                 px="10px"
                 py="6px"
                 h="auto"
                 boxShadow="0px 2px 3px 0px rgba(0,0,0,0.04)"
                 leftIcon={<Icon as={MdPictureAsPdf} w="18px" h="18px" />}
                 fontSize="13px"
                 fontWeight="400"
                 color="#171D28"
                 fontFamily="Poppins, sans-serif"
                 _hover={{ bg: '#FCFCFC' }}
               >
                 Générer Rapport
               </Button>
             </HStack>
           </Flex>

           {/* Contenu principal: Liste à gauche et métriques à droite */}
           <Flex gap="20px" align="flex-start" direction={{ base: 'column', lg: 'row' }}>
             {/* Liste des personnes */}
             <Card
               bg="white"
               p="20px"
               pt="20px"
               borderRadius="12px"
               boxShadow="0px 0px 10px 0px rgba(0,0,0,0.06)"
               w={{ base: '100%', lg: '506px' }}
               flexShrink={0}
               border="1px solid #E5E5E5"
             >
               <VStack align="stretch" spacing="16px">
                 {/* Barre de recherche */}
                 <InputGroup>
                   <InputLeftElement pointerEvents="none" h="100%">
                     <Icon as={MdSearch} color="#656C7A" w="16px" h="16px" />
                   </InputLeftElement>
                   <Input
                     placeholder="Recherche d'une ambulancier..."
                     value={performanceSearch}
                     onChange={(e) => setPerformanceSearch(e.target.value)}
                     bg="white"
                     border="1px solid #E5E5E5"
                     borderRadius="8px"
                     h="40px"
                     pl="40px"
                     fontSize="13px"
                     color="#171D28"
                     fontFamily="Poppins, sans-serif"
                     _placeholder={{ color: '#656C7A', fontSize: '13px' }}
                     _focus={{ borderColor: '#006133', boxShadow: '0 0 0 1px #006133' }}
                   />
                 </InputGroup>

                 {/* Liste des personnes */}
                 {loadingPerformance ? (
                   <LoadingSpinner message="Chargement des personnes..." fullHeight />
                 ) : performancePersonnes.length === 0 ? (
                   <Text fontSize="13px" color="#656C7A" fontFamily="Poppins, sans-serif" textAlign="center" py="40px">
                     Aucune donnée disponible
                   </Text>
                 ) : (
                   <Box
                     maxH="400px"
                     overflowY="auto"
                     pr="4px"
                     css={{
                       '&::-webkit-scrollbar': {
                         width: '6px',
                       },
                       '&::-webkit-scrollbar-track': {
                         background: '#F5F5F5',
                         borderRadius: '10px',
                       },
                       '&::-webkit-scrollbar-thumb': {
                         background: '#D0D5DD',
                         borderRadius: '10px',
                       },
                       '&::-webkit-scrollbar-thumb:hover': {
                         background: '#98A2B3',
                       },
                     }}
                   >
                     <VStack align="stretch" spacing="12px">
                       {performancePersonnes
                         .filter(p => {
                           // Filtrer par recherche uniquement (le rôle est déjà filtré par l'API)
                           return p.nom.toLowerCase().includes(performanceSearch.toLowerCase());
                         })
                         .map((personne) => (
                           <Box
                             key={personne.id}
                             bg={personne.selected ? '#EFF6FF' : 'white'}
                             borderRadius="12px"
                             p="14px"
                             cursor="pointer"
                             transition="all 0.2s"
                             onClick={() => {
                               // Si l'utilisateur est déjà sélectionné, ouvrir le modal avec les détails
                               if (personne.selected && personne.user_id) {
                                 fetchUserDetail(personne.user_id);
                                 onUserDetailOpen();
                                 return;
                               }

                               // Sinon, sélectionner l'utilisateur
                               setPerformancePersonnes(prev => prev.map(p => ({
                                 ...p,
                                 selected: p.id === personne.id
                               })));
                               setSelectedPerformanceUser(personne);
                               // Mettre à jour les métriques avec les données de l'utilisateur sélectionné
                               setPerformanceData({
                                 metrics: {
                                   missionsTotales: {
                                     valeur: personne.nombre_missions || 0,
                                     evolution: 0,
                                     type: 'min'
                                   },
                                   missionsAcceptees: {
                                     valeur: personne.nombre_missions_acceptees ?? personne.nombre_missions ?? 0,
                                     evolution: 0,
                                     type: 'min'
                                   },
                                   missionsAnnulees: {
                                     valeur: personne.nombre_missions_annulees ?? 0,
                                     evolution: 0,
                                     type: '%'
                                   },
                                   delaiAcceptation: {
                                     valeur: `${Math.round(parseFloat(personne.temps_reactivite?.moyenne_secondes || 0))} Sec`,
                                     evolution: null
                                   },
                                   delaiIntervention: {
                                     valeur: personne.delai_moyen_intervention_minutes != null
                                       ? `${personne.delai_moyen_intervention_minutes} min`
                                       : `${Math.round(parseFloat(personne.respect_delais_intervention?.moyenne_secondes || 0) / 60)} min`,
                                     evolution: null
                                   },
                                   delaiMissions: {
                                     valeur: personne.delai_moyen_missions_minutes != null
                                       ? `${personne.delai_moyen_missions_minutes} min`
                                       : '0 min',
                                     evolution: null
                                   },
                                   nombreReclamations: {
                                     valeur: personne.nombre_reclamations ?? 0,
                                     evolution: null
                                   }
                                 }
                               });
                             }}
                           >
                             <Flex justify="space-between" align="center" gap="12px">
                               <HStack spacing="12px" flex="1" minW="0">
                                 {/* Avatar */}
                                 {personne.photo ? (
                                   <Box
                                     as="img"
                                     src={personne.photo}
                                     alt={personne.nom}
                                     w="40px"
                                     h="40px"
                                     borderRadius="8px"
                                     objectFit="cover"
                                     flexShrink={0}
                                   />
                                 ) : (
                                   <Box
                                     w="40px"
                                     h="40px"
                                     borderRadius="8px"
                                     bg="#F0F0F0"
                                     display="flex"
                                     alignItems="center"
                                     justifyContent="center"
                                     flexShrink={0}
                                   >
                                     <Text fontSize="14px" color="#656C7A" fontWeight="600" fontFamily="Poppins, sans-serif">
                                       {personne.nom.charAt(0).toUpperCase()}
                                     </Text>
                                   </Box>
                                 )}
                                 {/* Nom et ID sur une seule ligne */}
                                 <Text
                                   fontSize="14px"
                                   fontWeight="400"
                                   color={personne.selected ? '#006133' : '#171D28'}
                                   fontFamily="Poppins, sans-serif"
                                   noOfLines={1}
                                 >
                                   {personne.nom} - {personne.code}
                                 </Text>
                               </HStack>
                               <HStack spacing="8px" align="center" flexShrink={0}>
                                 {/* Badge avec note et étoile */}
                                 <Badge
                                   bg="#FFF8DD"
                                   border="1px solid rgba(246,177,0,0.2)"
                                   borderRadius="100px"
                                   px="10px"
                                   py="5px"
                                   display="flex"
                                   alignItems="center"
                                   gap="4px"
                                 >
                                   <Text
                                     fontSize="13px"
                                     fontWeight="600"
                                     color="#171D28"
                                     fontFamily="Poppins, sans-serif"
                                   >
                                     {personne.etoile_globale > 0 ? personne.etoile_globale.toFixed(1) : '0.0'}
                                   </Text>
                                   <Icon
                                     as={MdStar}
                                     w="16px"
                                     h="16px"
                                     color="#F6B100"
                                     fill="#F6B100"
                                   />
                                 </Badge>
                                 {/* Flèche vers la droite */}
                                 <Icon
                                   as={MdChevronRight}
                                   w="20px"
                                   h="20px"
                                   color={personne.selected ? '#006133' : '#656C7A'}
                                 />
                               </HStack>
                             </Flex>
                           </Box>
                         ))}
                     </VStack>
                   </Box>
                 )}
               </VStack>
             </Card>

             {/* Métriques à droite */}
             <VStack align="stretch" spacing="20px" flex="1">
               {/* Première rangée: Missions */}
               <SimpleGrid columns={{ base: 1, md: 3 }} spacing="20px">
                 {/* Nombre total de missions */}
                 <Card
                   bg="white"
                   border="1px solid #E5E5E5"
                   p="20px"
                   pt="14px"
                   pb="20px"
                   borderRadius="12px"
                   boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                   h="150px"
                 >
                   <VStack align="stretch" spacing="10px">
                     <Flex justify="space-between" align="center">
                       <Text
                         fontSize="14px"
                         fontWeight="500"
                         color="#171D28"
                         fontFamily="Poppins, sans-serif"
                         lineHeight="1.2"
                       >
                         Nombre total<br />de missions
                       </Text>
                       <Box
                         bg="#EFF6FF"
                         border="1px solid rgba(69,156,233,0.2)"
                         borderRadius="6px"
                         w="36px"
                         h="36px"
                         display="flex"
                         alignItems="center"
                         justifyContent="center"
                       >
                         <Icon as={MdAddTask} w="20px" h="20px" color="#006133" />
                       </Box>
                     </Flex>
                     <Text
                       fontSize="28px"
                       fontWeight="600"
                       color="#171D28"
                       fontFamily="Oswald, sans-serif"
                       lineHeight="1.2"
                     >
                       {performanceData.metrics.missionsTotales.valeur}
                     </Text>
                     <HStack spacing="10px">
                       <Badge
                         bg="#EAF8FA"
                         border="1px solid rgba(41,186,205,0.2)"
                         borderRadius="4px"
                         px="3px"
                         py="3px"
                         fontSize="12px"
                         fontWeight="500"
                         color="#006133"
                         fontFamily="Poppins, sans-serif"
                       >
                         <Icon as={MdTrendingUp} w="12px" h="12px" mr="5px" display="inline" />
                         {performanceData.metrics.missionsTotales.evolution} {performanceData.metrics.missionsTotales.type}
                       </Badge>
                       <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                         vs mois dernier
                       </Text>
                     </HStack>
                   </VStack>
                 </Card>

                 {/* Missions acceptées */}
                 <Card
                   bg="white"
                   border="1px solid #E5E5E5"
                   p="20px"
                   pt="14px"
                   pb="20px"
                   borderRadius="12px"
                   boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                   h="150px"
                 >
                   <VStack align="stretch" spacing="10px">
                     <Flex justify="space-between" align="center">
                       <Text
                         fontSize="14px"
                         fontWeight="500"
                         color="#171D28"
                         fontFamily="Poppins, sans-serif"
                         lineHeight="1.2"
                       >
                         Nombre total<br />de missions acceptés
                       </Text>
                       <Box
                         bg="#EAF8FA"
                         border="1px solid rgba(41,186,205,0.2)"
                         borderRadius="6px"
                         w="36px"
                         h="36px"
                         display="flex"
                         alignItems="center"
                         justifyContent="center"
                       >
                         <Icon as={MdCheckCircle} w="20px" h="20px" color="#006133" />
                       </Box>
                     </Flex>
                     <Text
                       fontSize="28px"
                       fontWeight="600"
                       color="#171D28"
                       fontFamily="Oswald, sans-serif"
                       lineHeight="1.2"
                     >
                       {performanceData.metrics.missionsAcceptees.valeur}
                     </Text>
                     <HStack spacing="10px">
                       <Badge
                         bg="#EAF8FA"
                         border="1px solid rgba(41,186,205,0.2)"
                         borderRadius="4px"
                         px="3px"
                         py="3px"
                         fontSize="12px"
                         fontWeight="500"
                         color="#006133"
                         fontFamily="Poppins, sans-serif"
                       >
                         <Icon as={MdTrendingUp} w="12px" h="12px" mr="5px" display="inline" />
                         {performanceData.metrics.missionsAcceptees.evolution} {performanceData.metrics.missionsAcceptees.type}
                       </Badge>
                     </HStack>
                   </VStack>
                 </Card>

                 {/* Missions annulées */}
                 <Card
                   bg="white"
                   border="1px solid #E5E5E5"
                   p="20px"
                   pt="14px"
                   pb="20px"
                   borderRadius="12px"
                   boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                   h="150px"
                 >
                   <VStack align="stretch" spacing="10px">
                     <Flex justify="space-between" align="center">
                       <Text
                         fontSize="14px"
                         fontWeight="500"
                         color="#171D28"
                         fontFamily="Poppins, sans-serif"
                         lineHeight="1.2"
                       >
                         Nombre total<br />de missions annulés
                       </Text>
                       <Box w="36px" h="36px">
                         <Icon as={MdRemove} w="36px" h="36px" color="#F8285A" />
                       </Box>
                     </Flex>
                     <HStack spacing="10px" align="flex-end">
                       <Text
                         fontSize="28px"
                         fontWeight="600"
                         color="#171D28"
                         fontFamily="Oswald, sans-serif"
                         lineHeight="1.2"
                       >
                         {performanceData.metrics.missionsAnnulees.valeur}
                       </Text>
                       <Badge
                         bg="#EAF8FA"
                         border="1px solid rgba(41,186,205,0.2)"
                         borderRadius="4px"
                         px="3px"
                         py="3px"
                         fontSize="12px"
                         fontWeight="500"
                         color="#006133"
                         fontFamily="Poppins, sans-serif"
                       >
                         <Icon as={MdTrendingUp} w="12px" h="12px" mr="5px" display="inline" />
                         {performanceData.metrics.missionsAnnulees.evolution}%
                       </Badge>
                     </HStack>
                   </VStack>
                 </Card>
               </SimpleGrid>

               {/* Deuxième rangée: Délais (masquée pour Régulateur) */}
               {performanceFilter !== 'regulateur' && (
               <SimpleGrid columns={{ base: 1, md: 3 }} spacing="20px">
                 {/* Délai moyen d'acceptation */}
                 <Card
                   bg="white"
                   border="1px solid #E5E5E5"
                   p="20px"
                   pt="14px"
                   pb="20px"
                   borderRadius="12px"
                   boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                 >
                   <VStack align="stretch" spacing="10px">
                     <Flex justify="space-between" align="center">
                       <Text fontSize="14px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                         Délai moyen d'acceptation.
                       </Text>
                       <Box
                         bg="#EFF6FF"
                         border="1px solid rgba(69,156,233,0.2)"
                         borderRadius="6px"
                         w="36px"
                         h="36px"
                         display="flex"
                         alignItems="center"
                         justifyContent="center"
                       >
                         <Icon as={MdAccessTime} w="20px" h="20px" color="#006133" />
                       </Box>
                     </Flex>
                     <Text
                       fontSize="28px"
                       fontWeight="600"
                       color="#171D28"
                       fontFamily="Oswald, sans-serif"
                       lineHeight="1.2"
                     >
                       {performanceData.metrics.delaiAcceptation.valeur}
                     </Text>
                   </VStack>
                 </Card>

                 {/* Délai moyen d'intervention */}
                 <Card
                   bg="white"
                   border="1px solid #E5E5E5"
                   p="20px"
                   pt="14px"
                   pb="20px"
                   borderRadius="12px"
                   boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                 >
                   <VStack align="stretch" spacing="10px">
                     <Flex justify="space-between" align="center">
                       <Text
                         fontSize="14px"
                         fontWeight="500"
                         color="#171D28"
                         fontFamily="Poppins, sans-serif"
                         lineHeight="1.2"
                       >
                         Délai moyen d'intervention.
                       </Text>
                       <Box
                         bg="#FFF8DD"
                         border="1px solid rgba(246,177,0,0.2)"
                         borderRadius="6px"
                         w="36px"
                         h="36px"
                         display="flex"
                         alignItems="center"
                         justifyContent="center"
                       >
                         <Icon as={MdTimer} w="18px" h="18px" color="#F6B100" />
                       </Box>
                     </Flex>
                     <Text
                       fontSize="28px"
                       fontWeight="600"
                       color="#171D28"
                       fontFamily="Oswald, sans-serif"
                       lineHeight="1.2"
                     >
                       {performanceData.metrics.delaiIntervention.valeur}
                     </Text>
                   </VStack>
                 </Card>

                 {/* Délai moyen des missions */}
                 <Card
                   bg="white"
                   border="1px solid #E5E5E5"
                   p="20px"
                   pt="14px"
                   pb="20px"
                   borderRadius="12px"
                   boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                 >
                   <VStack align="stretch" spacing="10px">
                     <Flex justify="space-between" align="center">
                       <Text
                         fontSize="14px"
                         fontWeight="500"
                         color="#171D28"
                         fontFamily="Poppins, sans-serif"
                         lineHeight="1.2"
                       >
                         Délai moyen des missions.
                       </Text>
                       <Box
                         bg="#FFF8DD"
                         border="1px solid rgba(246,177,0,0.2)"
                         borderRadius="6px"
                         w="36px"
                         h="36px"
                         display="flex"
                         alignItems="center"
                         justifyContent="center"
                       >
                         <Icon as={MdTimer} w="18px" h="18px" color="#F6B100" />
                       </Box>
                     </Flex>
                     <Text
                       fontSize="28px"
                       fontWeight="600"
                       color="#171D28"
                       fontFamily="Oswald, sans-serif"
                       lineHeight="1.2"
                     >
                       {performanceData.metrics.delaiMissions.valeur}
                     </Text>
                   </VStack>
                 </Card>
               </SimpleGrid>
               )}

               {/* Troisième rangée: Nombre de réclamations */}
               <SimpleGrid columns={{ base: 1, md: 1 }} spacing="20px">
                 <Card
                   bg="white"
                   border="1px solid #E5E5E5"
                   p="20px"
                   pt="14px"
                   pb="20px"
                   borderRadius="12px"
                   boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                   w={{ base: '100%', md: '344.67px' }}
                 >
                 <VStack align="stretch" spacing="10px">
  <Flex justify="space-between" align="center">
    <Text
      fontSize="14px"
      fontWeight="500"
      fontFamily="Poppins, sans-serif"
    >
      Nombre de réclamations
    </Text>

    <Box
      bg="rgba(211,0,0,0.08)"
      border="1px solid rgba(211,0,0,0.3)"
      borderRadius="6px"
      w="36px"
      h="36px"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Icon as={MdShield} w="20px" h="20px" color="#D30000" />
    </Box>
  </Flex>

  <Text
    fontSize="28px"
    fontWeight="600"
    fontFamily="Oswald, sans-serif"
    lineHeight="1.2"
  >
    {performanceData.metrics.nombreReclamations.valeur
      .toString()
      .padStart(2, "0")}
  </Text>
</VStack>
                 </Card>
               </SimpleGrid>
             </VStack>
           </Flex>
         </VStack>
       </Card>
        )}

        {/* Section 5: Qualité & Conformité */}
        {isAnalysisSelected('conformite') && (
        <Card bg="white" border="1px solid #E5E5E5" p="20px" borderRadius="12px" mb="30px">
          <VStack align="stretch" spacing="20px">
            {/* Header */}
            <Flex justify="space-between" align="center" wrap="wrap" gap="10px">
              <Heading fontSize="16px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                Qualité & Conformité
              </Heading>
              <HStack spacing="10px" flex="1" justify="flex-end">


              </HStack>
            </Flex>

            {/* Première rangée: 4 cartes de métriques */}
            <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing="20px">
              {/* Réclamations totales */}
              <Card
                bg="white"
                border="1px solid #E5E5E5"
                p="20px"
                pt="14px"
                pb="20px"
                borderRadius="12px"
                boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                flex="1"
              >
                <VStack align="stretch" spacing="10px">
                  <Flex justify="space-between" align="center">
                    <Text fontSize="14px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                      Réclamations totales
                    </Text>
                    <Box
                      bg="#EFF6FF"
                      border="1px solid rgba(69,156,233,0.2)"
                      borderRadius="6px"
                      w="36px"
                      h="36px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Icon as={MdInfo} w="20px" h="20px" color="#006133" />
                    </Box>
                  </Flex>
                  <Text
                    fontSize="28px"
                    fontWeight="600"
                    color="#171D28"
                    fontFamily="Oswald, sans-serif"
                    lineHeight="1.2"
                  >
                    {qualiteData.reclamationsTotales.valeur}
                  </Text>
                  <HStack spacing="10px">
                    <Badge
                      bg="#EAF8FA"
                      border="1px solid rgba(41,186,205,0.2)"
                      borderRadius="4px"
                      px="3px"
                      py="3px"
                      fontSize="12px"
                      fontWeight="500"
                      color="#006133"
                      fontFamily="Poppins, sans-serif"
                    >
                      <Icon as={MdTrendingUp} w="12px" h="12px" mr="5px" display="inline" />
                      {qualiteData.reclamationsTotales.evolution} {qualiteData.reclamationsTotales.type}
                    </Badge>
                    <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                      vs mois dernier
                    </Text>
                  </HStack>
                </VStack>
              </Card>

              {/* Taux de réclamation */}
              <Card
                bg="white"
                border="1px solid #E5E5E5"
                p="20px"
                pt="14px"
                pb="20px"
                borderRadius="12px"
                boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                flex="1"
              >
                <VStack align="stretch" spacing="10px">
                  <Flex justify="space-between" align="center">
                    <Text fontSize="14px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                      Taux de réclamation
                    </Text>
                    <Box
                      bg="#FFEEF3"
                      border="1px solid rgba(248,40,90,0.2)"
                      borderRadius="6px"
                      w="36px"
                      h="36px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Icon as={MdRemove} w="20px" h="20px" color="#F8285A" />
                    </Box>
                  </Flex>
                  <Text
                    fontSize="28px"
                    fontWeight="600"
                    color="#171D28"
                    fontFamily="Oswald, sans-serif"
                    lineHeight="1.2"
                  >
                    {qualiteData.tauxReclamation.valeur}%
                  </Text>
                  <HStack spacing="10px">
                    <Badge
                      bg="#EAF8FA"
                      border="1px solid rgba(41,186,205,0.2)"
                      borderRadius="4px"
                      px="3px"
                      py="3px"
                      fontSize="12px"
                      fontWeight="500"
                      color="#006133"
                      fontFamily="Poppins, sans-serif"
                    >
                      <Icon as={MdTrendingUp} w="12px" h="12px" mr="5px" display="inline" />
                      {qualiteData.tauxReclamation.evolution} {qualiteData.tauxReclamation.type}
                    </Badge>
                    <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                      vs mois dernier
                    </Text>
                  </HStack>
                </VStack>
              </Card>

              {/* Délai traitement moyen */}
              <Card
                bg="white"
                border="1px solid #E5E5E5"
                p="20px"
                pt="14px"
                pb="20px"
                borderRadius="12px"
                boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                flex="1"
              >
                <VStack align="stretch" spacing="10px">
                  <Flex justify="space-between" align="center">
                    <Text fontSize="14px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                      Délai traitement moyen
                    </Text>
                    <Box
                      bg="#FFF8DD"
                      border="1px solid rgba(246,177,0,0.2)"
                      borderRadius="6px"
                      w="36px"
                      h="36px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Icon as={MdAccessTime} w="18px" h="18px" color="#F6B100" />
                    </Box>
                  </Flex>
                  <Text
                    fontSize="28px"
                    fontWeight="600"
                    color="#171D28"
                    fontFamily="Oswald, sans-serif"
                    lineHeight="1.2"
                  >
                    {qualiteData.delaiTraitement.valeur}
                  </Text>
                  <HStack spacing="10px">
                    <Badge
                      bg="#EAF8FA"
                      border="1px solid rgba(41,186,205,0.2)"
                      borderRadius="4px"
                      px="3px"
                      py="3px"
                      fontSize="12px"
                      fontWeight="500"
                      color="#006133"
                      fontFamily="Poppins, sans-serif"
                    >
                      <Icon as={MdTrendingUp} w="12px" h="12px" mr="5px" display="inline" />
                      +{qualiteData.delaiTraitement.evolution}%
                    </Badge>
                    <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                      vs mois dernier
                    </Text>
                  </HStack>
                </VStack>
              </Card>

              {/* Taux de satisfaction */}
              <Card
                bg="white"
                border="1px solid #E5E5E5"
                p="20px"
                pt="14px"
                pb="20px"
                borderRadius="12px"
                boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                flex="1"
              >
                <VStack align="stretch" spacing="10px">
                  <Flex justify="space-between" align="center">
                    <Text fontSize="14px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                      Taux de satisfaction
                    </Text>
                    <Box
                      bg="#EAF8FA"
                      border="1px solid rgba(41,186,205,0.2)"
                      borderRadius="6px"
                      w="36px"
                      h="36px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Icon as={MdShield} w="20px" h="20px" color="#006133" />
                    </Box>
                  </Flex>
                  <Text
                    fontSize="28px"
                    fontWeight="600"
                    color="#171D28"
                    fontFamily="Oswald, sans-serif"
                    lineHeight="1.2"
                  >
                    {qualiteData.tauxSatisfaction.valeur}%
                  </Text>
                  <HStack spacing="10px">
                    <Badge
                      bg="#EAF8FA"
                      border="1px solid rgba(41,186,205,0.2)"
                      borderRadius="4px"
                      px="3px"
                      py="3px"
                      fontSize="12px"
                      fontWeight="500"
                      color="#006133"
                      fontFamily="Poppins, sans-serif"
                    >
                      <Icon as={MdTrendingUp} w="12px" h="12px" mr="5px" display="inline" />
                      +{qualiteData.tauxSatisfaction.evolution}%
                    </Badge>
                    <Text fontSize="13px" color="#656C7A" fontWeight="500" fontFamily="Poppins, sans-serif">
                      vs mois dernier
                    </Text>
                  </HStack>
                </VStack>
              </Card>
            </SimpleGrid>

            {/* Deuxième rangée: Graphiques */}
            <Flex gap="20px" direction={{ base: 'column', lg: 'row' }}>
              {/* Évolution des réclamations */}
              <Card
                bg="white"
                border="1px solid #E5E5E5"
                borderRadius="12px"
                boxShadow="0px 0px 10px 0px rgba(0,0,0,0.06)"
                flex="1"
                overflow="hidden"
              >
                <VStack align="stretch" spacing="20px" p="20px" pt="20px">
                  <Text fontSize="14px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                    Évolution des réclamations
                  </Text>
                  <Box h="326px" pb="20px" position="relative">
                    <Chart
                      type="area"
                      height={326}
                      series={[
                        {
                          name: 'Réclamations',
                          data: qualiteData.evolutionReclamations.series
                        }
                      ]}
                      options={{
                        chart: {
                          type: 'area',
                          fontFamily: 'Poppins, sans-serif',
                          toolbar: { show: false },
                          zoom: { enabled: false },
                          animations: {
                            enabled: false
                          }
                        },
                        dataLabels: { enabled: false },
                        stroke: {
                          curve: 'smooth',
                          width: 2,
                          colors: ['#006133']
                        },
                        fill: {
                          type: 'gradient',
                          gradient: {
                            shadeIntensity: 1,
                            opacityFrom: 0.7,
                            opacityTo: 0.3,
                            stops: [0, 100],
                            colorStops: [
                              {
                                offset: 0,
                                color: '#006133',
                                opacity: 0.7
                              },
                              {
                                offset: 100,
                                color: '#006133',
                                opacity: 0.3
                              }
                            ]
                          }
                        },
                        xaxis: {
                          categories: qualiteData.evolutionReclamations.categories,
                          labels: {
                            style: {
                              fontSize: '13px',
                              fontFamily: 'Poppins, sans-serif',
                              fontWeight: 500,
                              colors: '#171D28'
                            }
                          }
                        },
                        yaxis: {
                          labels: {
                            style: {
                              fontSize: '13px',
                              fontFamily: 'Poppins, sans-serif',
                              fontWeight: 500,
                              colors: '#171D28'
                            }
                          },
                          min: 0,
                          max: 80,
                          tickAmount: 5
                        },
                        grid: {
                          borderColor: '#E5E5E5',
                          strokeDashArray: 1,
                          xaxis: { lines: { show: false } },
                          yaxis: { lines: { show: true } }
                        },
                        colors: ['#006133'],
                        tooltip: {
                          theme: 'light',
                          style: {
                            fontSize: '13px',
                            fontFamily: 'Poppins, sans-serif'
                          }
                        },
                        markers: {
                          size: 6,
                          colors: ['#006133'],
                          strokeColors: '#fff',
                          strokeWidth: 4,
                          hover: { size: 8 },
                          offsetY: 0,

                        }
                      }}
                    />
                  </Box>
                  <Box
                    bg="#EFF6FF"
                    border="1px solid rgba(69,156,233,0.2)"
                    borderRadius="6px"
                    px="14px"
                    py="10px"
                    display="flex"
                    alignItems="center"
                    gap="6px"
                  >
                    <Icon as={MdTimer} w="16px" h="16px" color="#006133" />
                    <Text
                      flex="1"
                      fontSize="14px"
                      fontWeight="500"
                      color="#171D28"
                      fontFamily="Poppins, sans-serif"
                    >
                      Total réclamations
                    </Text>
                    <Text
                      fontSize="16px"
                      fontWeight="700"
                      color="#006133"
                      fontFamily="Poppins, sans-serif"
                      whiteSpace="nowrap"
                    >
                      {qualiteData.evolutionReclamations.series.reduce((acc, val) => acc + val, 0)} réclamations
                    </Text>
                  </Box>
                </VStack>
              </Card>

              {/* Répartition / type */}
              {(() => {
                const rt = qualiteData.repartitionType;
                const config = [
                  { key: 'retard', label: 'Retard' },
                  { key: 'qualitePriseEnCharge', label: 'Qualité de prise en charge' },
                  { key: 'defaillancePriseEnCharge', label: 'Défaillance de prise en charge' },
                  { key: 'hygiene', label: 'Hygiène' },
                  { key: 'facturation', label: 'Facturation' },
                  { key: 'securite', label: 'Sécurité' },
                  { key: 'comportement', label: 'Comportement' },
                  { key: 'autre', label: 'Autre' }
                ];
                const totalRepartition = config.reduce((sum, { key }) => sum + (rt[key]?.valeur ?? 0), 0);
                const motifsExistants = config
                  .map(({ key, label }) => ({
                    key,
                    label,
                    valeur: rt[key]?.valeur ?? 0,
                    couleur: rt[key]?.couleur ?? '#656C7A'
                  }))
                  .filter((m) => m.valeur > 0)
                  .map((m) => ({
                    ...m,
                    pourcentage: totalRepartition > 0 ? parseFloat(((m.valeur / totalRepartition) * 100).toFixed(1)) : 0
                  }));
                return (
                  <Card
                    bg="white"
                    border="1px solid #E5E5E5"
                    borderRadius="12px"
                    boxShadow="0px 0px 10px 0px rgba(0,0,0,0.06)"
                    p="20px"
                    pb="20px"
                    pt="20px"
                    maxw="650px"
                    w="650px"
                  >
                    <VStack align="stretch" spacing="10px" flex="1">
                      <Text fontSize="14px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                        Répartition / type
                      </Text>
                      <Flex h="244px" align="center" pt="30px" direction={{ base: 'column', md: 'row' }}>
                        {/* Donut Chart - uniquement motifs existants */}
                        <Box position="relative" w="200px" h="150px" flexShrink={0}>
                          {motifsExistants.length > 0 ? (
                            <Chart
                              type="donut"
                              height={200}
                              series={motifsExistants.map((m) => m.valeur)}
                              options={{
                                chart: {
                                  type: 'donut',
                                  fontFamily: 'Poppins, sans-serif'
                                },
                                labels: motifsExistants.map((m) => m.label),
                                colors: motifsExistants.map((m) => m.couleur),
                                plotOptions: {
                                  pie: {
                                    donut: {
                                      size: '70%',
                                      labels: { show: false }
                                    }
                                  }
                                },
                                dataLabels: { enabled: false },
                                legend: { show: false }
                              }}
                            />
                          ) : (
                            <Box
                              w="200px"
                              h="150px"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              bg="#F9F9F9"
                              borderRadius="12px"
                            >
                              <Text fontSize="13px" color="#656C7A" fontFamily="Poppins, sans-serif">
                                Aucun motif
                              </Text>
                            </Box>
                          )}
                          <Box
                            position="absolute"
                            top="50%"
                            left="50%"
                            transform="translate(-50%, -50%)"
                            textAlign="center"
                            pointerEvents="none"
                          >
                            <Text
                              fontSize="28px"
                              fontWeight="600"
                              color="#171D28"
                              fontFamily="Oswald, sans-serif"
                              lineHeight="1.2"
                            >
                              {totalRepartition}
                            </Text>
                            <Text
                              fontSize="14px"
                              fontWeight="500"
                              color="#656C7A"
                              fontFamily="Poppins, sans-serif"
                              lineHeight="16px"
                              w="110px"
                            >
                              Total
                            </Text>
                          </Box>
                        </Box>

                        {/* Légende - uniquement motifs existants avec % */}
                        <VStack align="stretch" spacing="5px" flex="1" minW="385px">
                          {motifsExistants.length > 0 ? (
                            motifsExistants.map((motif) => (
                              <HStack key={motif.key} spacing="5px">
                                <Box
                                  w="9px"
                                  h="20px"
                                  bg={motif.couleur}
                                  borderRadius="10px"
                                  flexShrink={0}
                                />
                                <Flex flex="1" justify="space-between" align="center" minW="0">
                                  <Text
                                    fontSize="13px"
                                    fontWeight="400"
                                    color="#171D28"
                                    fontFamily="Poppins, sans-serif"
                                    noOfLines={1}
                                  >
                                    {motif.label}
                                  </Text>
                                  <Text
                                    fontSize="13px"
                                    fontWeight="500"
                                    color="#171D28"
                                    fontFamily="Poppins, sans-serif"
                                    textAlign="right"
                                    whiteSpace="nowrap"
                                    ml="8px"
                                  >
                                    {motif.pourcentage}%
                                  </Text>
                                </Flex>
                              </HStack>
                            ))
                          ) : (
                            <Text fontSize="13px" color="#656C7A" fontFamily="Poppins, sans-serif">
                              Aucun motif de réclamation
                            </Text>
                          )}
                        </VStack>
                      </Flex>
                    </VStack>
                  </Card>
                );
              })()}
            </Flex>
          </VStack>
        </Card>
        )}

        {/* Section 6: Analyse Géographique */}
        {isAnalysisSelected('geographique') && (
        <Card bg="white" border="1px solid #E5E5E5" p="20px" borderRadius="12px" mb="30px">
          <VStack align="stretch" spacing="20px">
            {/* Header */}
            <Flex justify="space-between" align="center" wrap="wrap" gap="10px">
              <Heading fontSize="16px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                Analyse Géographique
              </Heading>
              <HStack spacing="10px" flex="1" justify="flex-end">
                {/* Boutons de filtre */}
                <Box
                  bg="#F9F9F9"
                  border="1px solid #E5E5E5"
                  borderRadius="8px"
                  p="3px"
                  display="flex"
                  gap="5px"
                >

                  <Button
                    size="sm"
                    h="30px"
                    px="10px"
                    py="3px"
                    borderRadius="6px"
                    bg="transparent"
                    color="#171D28"
                    fontSize="14px"
                    fontWeight="500"
                    fontFamily="Poppins, sans-serif"
                    onClick={() => setGeographiqueFilter('ambulancier')}
                    _hover={{ bg: 'transparent' }}
                  >
                    Ambulancier
                  </Button>

                </Box>

              </HStack>
            </Flex>

            {/* Première rangée: 3 cartes de métriques */}
            <SimpleGrid columns={{ base: 1, md: 3 }} spacing="20px">
              {/* Missions urbaines */}
              <Card
                bg="white"
                border="1px solid #E5E5E5"
                p="20px"
                pt="14px"
                pb="20px"
                borderRadius="12px"
                boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                flex="1"
              >
                <VStack align="stretch" spacing="10px">
                  <Flex justify="space-between" align="center">
                    <Text fontSize="14px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                      Missions urbaines
                    </Text>
                    <Box
                      bg="#FFEEF3"
                      border="1px solid rgba(248,40,90,0.2)"
                      borderRadius="6px"
                      w="36px"
                      h="36px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Icon as={MdMap} w="20px" h="20px" color="#F8285A" />
                    </Box>
                  </Flex>
                  <Text
                    fontSize="28px"
                    fontWeight="600"
                    color="#171D28"
                    fontFamily="Oswald, sans-serif"
                    lineHeight="1.2"
                  >
                    {geographiqueData.missionsUrbaines.valeur.toLocaleString()}
                  </Text>
                  <Text fontSize="13px" fontWeight="500" color="#656C7A" fontFamily="Poppins, sans-serif">
                    {geographiqueData.missionsUrbaines.pourcentage.toFixed(1)}% du total
                  </Text>
                </VStack>
              </Card>

              {/* Missions interurbaines */}
              <Card
                bg="white"
                border="1px solid #E5E5E5"
                p="20px"
                pt="14px"
                pb="20px"
                borderRadius="12px"
                boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                flex="1"
              >
                <VStack align="stretch" spacing="10px">
                  <Flex justify="space-between" align="center">
                    <Text fontSize="14px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                      Missions interurbaines
                    </Text>
                    <Box
                      bg="#FFF8DD"
                      border="1px solid rgba(246,177,0,0.2)"
                      borderRadius="6px"
                      w="36px"
                      h="36px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Icon as={MdRoute} w="20px" h="20px" color="#F6B100" />
                    </Box>
                  </Flex>
                  <Text
                    fontSize="28px"
                    fontWeight="600"
                    color="#171D28"
                    fontFamily="Oswald, sans-serif"
                    lineHeight="1.2"
                  >
                    {geographiqueData.missionsInterurbaines.valeur}
                  </Text>
                  <Text fontSize="13px" fontWeight="500" color="#656C7A" fontFamily="Poppins, sans-serif">
                    {geographiqueData.missionsInterurbaines.pourcentage.toFixed(1)}% du total
                  </Text>
                </VStack>
              </Card>

              {/* Rayon > 50km */}
              <Card
                bg="white"
                border="1px solid #E5E5E5"
                p="20px"
                pt="14px"
                pb="20px"
                borderRadius="12px"
                boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                flex="1"
              >
                <VStack align="stretch" spacing="10px">
                  <Flex justify="space-between" align="center">
                    <Text fontSize="14px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                      Rayon &gt; 50km
                    </Text>
                    <Box
                      bg="#EAF8FA"
                      border="1px solid rgba(41,186,205,0.2)"
                      borderRadius="6px"
                      w="36px"
                      h="36px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Icon as={MdCenterFocusStrong} w="20px" h="20px" color="#006133" />
                    </Box>
                  </Flex>
                  <Text
                    fontSize="28px"
                    fontWeight="600"
                    color="#171D28"
                    fontFamily="Oswald, sans-serif"
                    lineHeight="1.2"
                  >
                    {geographiqueData.rayonPlus50km.valeur}
                  </Text>
                  <Text fontSize="13px" fontWeight="500" color="#656C7A" fontFamily="Poppins, sans-serif">
                    {geographiqueData.rayonPlus50km.pourcentage.toFixed(1)}% du total
                  </Text>
                </VStack>
              </Card>
            </SimpleGrid>

            {/* Carte thermique */}
            <Card
              bg="white"
              border="1px solid #E5E5E5"
              borderRadius="12px"
              boxShadow="0px 0px 10px 0px rgba(0,0,0,0.06)"
              p="20px"
            >
              <VStack align="stretch" spacing="20px">
                <Text fontSize="16px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                  Carte thermique des missions
                </Text>
                <Box
                  bg="white"
                  border="1px solid #E5E5E5"
                  borderRadius="12px"
                  boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                  p="14px"
                  position="relative"
                  h="750px"
                  overflow="hidden"
                >
                  {/* Carte Google Maps */}
                  <Box
                    ref={mapRef}
                    h="750px"
                    w="100%"
                    borderRadius="10px"
                    position="relative"
                    overflow="hidden"
                  >
                    {!googleMapsLoaded && (
                      <Box
                        position="absolute"
                        inset="0"
                        bg="linear-gradient(135deg, #E5E5E5 0%, #F0F0F0 100%)"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        zIndex="1"
                      >
                        <LoadingSpinner message="Chargement de la carte..." size="md" />
                      </Box>
                    )}
                    {/* Panneau Statistiques - en haut à gauche */}
                    <Card
                      position="absolute"
                      top="16px"
                      left="16px"
                      bg="white"
                      border="1px solid #E5E5E5"
                      borderRadius="12px"
                      boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                      p="20px"
                      pt="14px"
                      w="266px"
                    >
                      <VStack align="stretch" spacing="14px">
                        <Text fontSize="14px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                          Statistiques
                        </Text>
                        <HStack spacing="10px">
                          <Text fontSize="13px" fontWeight="600" color="#171D28" fontFamily="Poppins, sans-serif">
                            Total points:
                          </Text>
                          <Text fontSize="14px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                            {geographiqueData.statistiques.totalPoints}
                          </Text>
                        </HStack>
                        <VStack align="stretch" spacing="10px">
                          <HStack spacing="10px">
                            <Text fontSize="13px" fontWeight="400" color="#171D28" fontFamily="Poppins, sans-serif">
                              Consultation à domicile
                            </Text>
                            <Text fontSize="14px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                              {geographiqueData.statistiques.consultationDomicile}
                            </Text>
                          </HStack>
                          <HStack spacing="10px">
                            <Text fontSize="13px" fontWeight="400" color="#171D28" fontFamily="Poppins, sans-serif">
                              Ambulance
                            </Text>
                            <Text fontSize="14px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                              {geographiqueData.statistiques.ambulance}
                            </Text>
                          </HStack>
                          <HStack spacing="10px">
                            <Text fontSize="13px" fontWeight="400" color="#171D28" fontFamily="Poppins, sans-serif">
                              Acte infirmier
                            </Text>
                            <Text fontSize="14px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                              {geographiqueData.statistiques.acteInfirmier}
                            </Text>
                          </HStack>
                        </VStack>
                      </VStack>
                    </Card>

                    {/* Panneau Types de mission - en bas à gauche */}
                    <Card
                      position="absolute"
                      top="215px"
                      left="16px"
                      bg="white"
                      border="1px solid #E5E5E5"
                      borderRadius="12px"
                      boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                      p="20px"
                      pt="14px"
                      w="266px"
                    >
                      <VStack align="stretch" spacing="20px">
                        <Text fontSize="14px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                          Types de mission
                        </Text>
                        <VStack align="stretch" spacing="10px">
                          <HStack spacing="10px">
                            <Box w="10px" h="10px" bg="#006133" borderRadius="20px" />
                            <Text fontSize="13px" fontWeight="400" color="#171D28" fontFamily="Poppins, sans-serif">
                              Consultation à domicile
                            </Text>
                          </HStack>
                          <HStack spacing="10px">
                            <Box w="10px" h="10px" bg="#F6B100" borderRadius="20px" />
                            <Text fontSize="13px" fontWeight="400" color="#171D28" fontFamily="Poppins, sans-serif">
                              Ambulance
                            </Text>
                          </HStack>
                          <HStack spacing="10px">
                            <Box w="10px" h="10px" bg="#F8285A" borderRadius="20px" />
                            <Text fontSize="13px" fontWeight="400" color="#171D28" fontFamily="Poppins, sans-serif">
                              Acte infirmier
                            </Text>
                          </HStack>
                        </VStack>
                      </VStack>
                    </Card>

                    {/* Badge Actualisation - en bas à droite */}
                    <Card
                      position="absolute"
                      bottom="16px"
                      right="16px"
                      bg="white"
                      border="1px solid #E5E5E5"
                      borderRadius="12px"
                      boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                      p="20px"
                      pt="14px"
                      display="flex"
                      alignItems="center"
                      gap="10px"
                    >
                      <Box position="relative" w="6px" h="6px">
                        <Box
                          position="absolute"
                          top="50%"
                          left="50%"
                          transform="translate(-50%, -50%)"
                          w="20px"
                          h="20px"
                          bg="rgba(41,186,205,0.1)"
                          borderRadius="100px"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Box
                            w="12px"
                            h="12px"
                            bg="rgba(41,186,205,0.2)"
                            borderRadius="100px"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                          >
                            <Box w="5px" h="5px" bg="#006133" borderRadius="20px" />
                          </Box>
                        </Box>
                      </Box>
                      <VStack align="start" spacing="5px">
                        <Text fontSize="11px" fontWeight="400" color="#171D28" fontFamily="Poppins, sans-serif">
                          Actualisation
                        </Text>
                        <Text fontSize="14px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                          Temps réel
                        </Text>
                      </VStack>
                    </Card>

                    {/* Boutons de contrôle - en haut à droite */}
                    <VStack
                      position="absolute"
                      top="16px"
                      right="16px"
                      spacing="10px"
                      align="stretch"
                    >
                      <Button
                        bg="white"
                        border="1px solid #E5E5E5"
                        borderRadius="6px"
                        boxShadow="0px 3px 4px 0px rgba(0,0,0,0.03)"
                        w="36px"
                        h="36px"
                        p="5px"
                        minW="36px"
                      >
                        <Icon as={MdCenterFocusStrong} w="16px" h="16px" color="#656C7A" />
                      </Button>
                      <VStack spacing="0" align="stretch">
                        <Button
                          bg="white"
                          border="1px solid #F3F3F3"
                          borderBottom="none"
                          borderRadius="6px 6px 0 0"
                          boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                          w="36px"
                          h="36px"
                          p="10px"
                          minW="36px"
                        >
                          <Icon as={MdAddTask} w="16px" h="16px" color="#171D28" />
                        </Button>
                        <Button
                          bg="white"
                          border="none"
                          borderRadius="0 0 6px 6px"
                          boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                          w="36px"
                          h="36px"
                          p="10px"
                          minW="36px"
                        >
                          <Box w="16px" h="1.563px" bg="#171D28" />
                        </Button>
                      </VStack>
                    </VStack>

                    {/* Boutons en bas à gauche */}
                    <HStack
                      position="absolute"
                      bottom="16px"
                      left="16px"
                      spacing="4px"
                    >
                      <Button
                        bg="white"
                        border="1px solid #E5E5E5"
                        borderRadius="12px"
                        boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                        px="20px"
                        py="14px"
                        fontSize="14px"
                        fontWeight="500"
                        color="#171D28"
                        fontFamily="Poppins, sans-serif"
                        _hover={{ bg: 'white' }}
                      >
                        Vu satellite
                      </Button>
                      <Button
                        bg="white"
                        border="1px solid #E5E5E5"
                        borderRadius="12px"
                        boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                        px="20px"
                        py="14px"
                        fontSize="14px"
                        fontWeight="500"
                        color="#171D28"
                        fontFamily="Poppins, sans-serif"
                        rightIcon={<Switch size="sm" colorScheme="blue" />}
                        _hover={{ bg: 'white' }}
                      >
                        Trafic en temps réel
                      </Button>
                    </HStack>
                  </Box>
                </Box>
              </VStack>
            </Card>
          </VStack>
        </Card>
        )}


        {/* Section 8: Flotte & Maintenance */}
        {isAnalysisSelected('flotte') && (
        <Card bg="white" border="1px solid #E5E5E5" p="20px" borderRadius="12px" mb="30px">
          <VStack align="stretch" spacing="20px">
            {/* Header */}
            <Flex justify="space-between" align="center" gap="14px">
              <Heading fontSize="16px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                Flotte & Maintenance
              </Heading>

            </Flex>

            {/* Première rangée: 4 cartes de métriques */}
            <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing="20px">
              {/* Véhicules actifs */}
              <Card
                bg="white"
                border="1px solid #E5E5E5"
                p="20px"
                pt="14px"
                pb="20px"
                borderRadius="12px"
                boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                flex="1"
              >
                <VStack align="stretch" spacing="10px">
                  <Flex justify="space-between" align="center">
                    <Text fontSize="14px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                      Véhicules actifs
                    </Text>
                    <Box
                      bg="#EFF6FF"
                      border="1px solid rgba(69,156,233,0.2)"
                      borderRadius="6px"
                      w="36px"
                      h="36px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Icon as={MdOutlineFireTruck} w="16px" h="16px" color="#006133" />
                    </Box>
                  </Flex>
                  <Text
                    fontSize="28px"
                    fontWeight="600"
                    color="#171D28"
                    fontFamily="Oswald, sans-serif"
                    lineHeight="1.2"
                  >
                    {flotteData.vehiculesActifs.valeur}
                  </Text>
                  <Text fontSize="13px" fontWeight="500" color="#656C7A" fontFamily="Poppins, sans-serif">
                    {flotteData.vehiculesActifs.description}
                  </Text>
                </VStack>
              </Card>

              {/* Pannes */}
              <Card
                bg="white"
                border="1px solid #E5E5E5"
                p="20px"
                pt="14px"
                pb="20px"
                borderRadius="12px"
                boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                flex="1"
              >
                <VStack align="stretch" spacing="10px">
                  <Flex justify="space-between" align="center">
                    <Text fontSize="14px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                      Pannes
                    </Text>
                    <Box
                      bg="#FFEEF3"
                      border="1px solid rgba(248,40,90,0.2)"
                      borderRadius="6px"
                      w="36px"
                      h="36px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Icon as={MdBuild} w="16px" h="16px" color="#F8285A" />
                    </Box>
                  </Flex>
                  <Text
                    fontSize="28px"
                    fontWeight="600"
                    color="#171D28"
                    fontFamily="Oswald, sans-serif"
                    lineHeight="1.2"
                  >
                    {flotteData.pannes.valeur.toString().padStart(2, '0')}
                  </Text>
                  <HStack spacing="10px">
                    <Badge
                      bg="#EAF8FA"
                      border="1px solid rgba(41,186,205,0.2)"
                      borderRadius="4px"
                      px="3px"
                      py="3px"
                      fontSize="12px"
                      fontWeight="500"
                      color="#006133"
                      fontFamily="Poppins, sans-serif"
                    >
                      <Icon as={MdTrendingUp} w="12px" h="12px" mr="5px" display="inline" />
                      {flotteData.pannes.evolution} {flotteData.pannes.type}
                    </Badge>
                    <Text fontSize="13px" fontWeight="500" color="#656C7A" fontFamily="Poppins, sans-serif">
                      vs mois dernier
                    </Text>
                  </HStack>
                </VStack>
              </Card>

              {/* Entretiens */}
              <Card
                bg="white"
                border="1px solid #E5E5E5"
                p="20px"
                pt="14px"
                pb="20px"
                borderRadius="12px"
                boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                flex="1"
              >
                <VStack align="stretch" spacing="10px">
                  <Flex justify="space-between" align="center">
                    <Text fontSize="14px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                      Entretiens
                    </Text>
                    <Box
                      bg="#FFF8DD"
                      border="1px solid rgba(246,177,0,0.2)"
                      borderRadius="6px"
                      w="36px"
                      h="36px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Icon as={MdBuild} w="16px" h="16px" color="#F6B100" />
                    </Box>
                  </Flex>
                  <Text
                    fontSize="28px"
                    fontWeight="600"
                    color="#171D28"
                    fontFamily="Oswald, sans-serif"
                    lineHeight="1.2"
                  >
                    {flotteData.entretiens.valeur.toString().padStart(2, '0')}
                  </Text>
                  <HStack spacing="10px">
                    <Badge
                      bg="#EAF8FA"
                      border="1px solid rgba(41,186,205,0.2)"
                      borderRadius="4px"
                      px="3px"
                      py="3px"
                      fontSize="12px"
                      fontWeight="500"
                      color="#006133"
                      fontFamily="Poppins, sans-serif"
                    >
                      <Icon as={MdTrendingUp} w="12px" h="12px" mr="5px" display="inline" />
                      {flotteData.entretiens.evolution} {flotteData.entretiens.type}
                    </Badge>
                    <Text fontSize="13px" fontWeight="500" color="#656C7A" fontFamily="Poppins, sans-serif">
                      vs mois dernier
                    </Text>
                  </HStack>
                </VStack>
              </Card>

            </SimpleGrid>

            {/* Deuxième rangée: Graphiques */}
            <Flex gap="20px" direction={{ base: 'column', lg: 'row' }}>
              {/* Pannes par véhicule */}
              <Card
                bg="white"
                border="1px solid #E5E5E5"
                borderRadius="12px"
                boxShadow="0px 0px 10px 0px rgba(0,0,0,0.06)"
                flex="1"
                w={{ base: '100%', lg: '980px' }}
                h="385px"
                overflow="hidden"
              >
                <VStack align="stretch" spacing="20px" p="20px" pt="20px" pb="20px" h="100%">
                  <Text fontSize="14px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                    Pannes par véhicule
                  </Text>
                  <Box flex="1" position="relative" minH="300px">
                    <Chart
                      type="bar"
                      height={300}
                      series={[
                        {
                          name: 'Pannes',
                          data: flotteData.pannesParVehicule.valeurs
                        }
                      ]}
                      options={{
                        chart: {
                          type: 'bar',
                          fontFamily: 'Poppins, sans-serif',
                          toolbar: { show: false },
                          stacked: false
                        },
                        plotOptions: {
                          bar: {
                            horizontal: false,
                            columnWidth: '60%',
                            borderRadius: 4,
                            distributed: true
                          }
                        },
                        dataLabels: {
                          enabled: true,
                          style: {
                            fontSize: '14px',
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 600,
                            colors: ['#171D28']
                          },
                          offsetY: -20
                        },
                        xaxis: {
                          categories: flotteData.pannesParVehicule.vehicules,
                          labels: {
                            style: {
                              fontSize: '13px',
                              fontFamily: 'Poppins, sans-serif',
                              fontWeight: 500,
                              colors: '#171D28'
                            }
                          }
                        },
                        yaxis: {
                          labels: {
                            style: {
                              fontSize: '13px',
                              fontFamily: 'Poppins, sans-serif',
                              colors: '#171D28'
                            }
                          }
                        },
                        colors: flotteData.pannesParVehicule.couleurs,
                        grid: {
                          borderColor: '#E5E5E5',
                          strokeDashArray: 1,
                          xaxis: { lines: { show: false } },
                          yaxis: { lines: { show: true } }
                        },
                        tooltip: {
                          theme: 'light',
                          style: {
                            fontSize: '13px',
                            fontFamily: 'Poppins, sans-serif'
                          }
                        }, legend: {
                          show: false
                        }
                      }}
                    />
                  </Box>
                </VStack>
              </Card>
            </Flex>
          </VStack>
        </Card>
        )}

        {/* Section 9: Analyse des médecins prescripteurs */}
        {isAnalysisSelected('medecins-prescripteurs') && (
        <Card bg="white" border="1px solid #E5E5E5" p="20px" borderRadius="12px" mb="30px">
          <VStack align="stretch" spacing="20px">
            {/* Header */}
            <Flex justify="space-between" align="center" gap="14px" wrap="wrap">
              <Heading fontSize="16px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif" flex="1">
                Analyse des médecins prescripteurs du transport d'ambulance
              </Heading>
            </Flex>

            {/* Première ligne: Taux de mission / Médecin (pleine largeur) */}
            <Card
              bg="white"
              border="1px solid #E5E5E5"
              borderRadius="12px"
              boxShadow="0px 0px 10px 0px rgba(0,0,0,0.06)"
              w="100%"
              overflow="hidden"
            >
              <VStack align="stretch" spacing="20px" p="20px">
                <Flex justify="space-between" align="center" wrap="wrap" gap="10px">
                  <Text fontSize="14px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                    Taux de mission / Médecin
                  </Text>
                  <InputGroup w="262px">
                    <InputLeftElement pointerEvents="none">
                      <Icon as={MdSearch} color="#656C7A" w="16px" h="16px" />
                    </InputLeftElement>
                    <Input
                      placeholder="Recherche d'un Médecin..."
                      bg="white"
                      border="1px solid #E5E5E5"
                      borderRadius="6px"
                      h="36px"
                      fontSize="11px"
                      color="#656C7A"
                      fontFamily="Poppins, sans-serif"
                      _placeholder={{ color: '#656C7A', fontSize: '11px' }}
                      value={searchMedecin}
                      onChange={(e) => setSearchMedecin(e.target.value)}
                    />
                  </InputGroup>
                </Flex>
                {loadingMedecins ? (
                  <Flex justify="center" align="center" h="200px">
                    <Text color="#656C7A">Chargement...</Text>
                  </Flex>
                ) : (() => {
                  // Filtrer les médecins selon la recherche
                  const filteredMedecins = medecinsData.medecins.filter(medecin => {
                    if (!searchMedecin) return true;
                    const searchLower = searchMedecin.toLowerCase();
                    const nomComplet = `${medecin.prenom || ''} ${medecin.nom || ''}`.toLowerCase();
                    return nomComplet.includes(searchLower);
                  });

                  if (filteredMedecins.length === 0) {
                    return (
                      <Flex justify="center" align="center" h="200px">
                        <Text color="#656C7A">Aucun médecin prescripteur trouvé</Text>
                      </Flex>
                    );
                  }

                  return (
                    <Box maxH="260px" overflowY="auto" pr="4">
                      <VStack align="stretch" spacing="10px">
                        {filteredMedecins.map((medecin) => {
                          // Calculer le max pour les barres de progression
                          const maxMissions = Math.max(...medecinsData.medecins.map(m => m.total_missions || 0), 1);
                          const pourcentageEnvoyees = ((medecin.missions_envoyees || 0) / maxMissions) * 100;
                          const pourcentageRecues = ((medecin.missions_recues || 0) / maxMissions) * 100;

                          return (
                            <Box
                              key={medecin.id}
                              bg="#FCFCFC"
                              border="1px solid #E5E5E5"
                              borderRadius="12px"
                              boxShadow="0px 2px 3px 0px rgba(0,0,0,0.04)"
                              p="14px"
                              minH="62px"
                            >
                              <Flex gap="14px" align="center" h="100%">
                                {/* Avatar et nom */}
                                <HStack spacing="10px" minW="200px">
                                  {medecin.photo ? (
                                    <Avatar size="sm" src={medecin.photo} name={`${medecin.prenom} ${medecin.nom}`} />
                                  ) : (
                                    <Box
                                      w="34px"
                                      h="34px"
                                      borderRadius="6px"
                                      border="1px solid #E5E5E5"
                                      bg="#F0F0F0"
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                    >
                                      <Text fontSize="12px" fontWeight="600" color="#656C7A">
                                        {(medecin.prenom || '').charAt(0)}{(medecin.nom || '').charAt(0)}
                                      </Text>
                                    </Box>
                                  )}
                                  <VStack align="start" spacing="0">
                                    <Text
                                      fontSize="14px"
                                      fontWeight="500"
                                      color="#171D28"
                                      fontFamily="Poppins, sans-serif"
                                    >
                                      Dr. {medecin.prenom} {medecin.nom}
                                    </Text>
                                    <Text fontSize="11px" color="#656C7A">
                                      {medecin.total_missions || 0} missions ({medecin.taux_global?.toFixed(1) || 0}%)
                                    </Text>
                                  </VStack>
                                </HStack>
                                {/* Barres de progression */}
                                <VStack align="stretch" spacing="4px" flex="1">
                                  {/* Barre Missions Envoyées (en cyan) */}
                                  <Flex gap="10px" h="16px" align="center">
                                    <Text fontSize="11px" color="#656C7A" minW="80px">Envoyées</Text>
                                    <Flex flex="1" gap="5px" align="center">
                                      <Box flex="1" h="7px" bg="#E5E5E5" borderRadius="6px" overflow="hidden">
                                        <Box h="7px" bg="#006133" borderRadius="6px" w={`${pourcentageEnvoyees}%`} maxW="100%" />
                                      </Box>
                                    </Flex>
                                    <Text fontSize="11px" fontWeight="700" color="#171D28" fontFamily="Poppins, sans-serif" minW="50px" textAlign="right">
                                      {medecin.missions_envoyees || 0} ({medecin.taux_envoyees?.toFixed(1) || 0}%)
                                    </Text>
                                  </Flex>
                                  {/* Barre Missions Reçues (en rouge) */}
                                  <Flex gap="10px" h="16px" align="center">
                                    <Text fontSize="11px" color="#656C7A" minW="80px">Reçues</Text>
                                    <Flex flex="1" gap="5px" align="center">
                                      <Box flex="1" h="7px" bg="#E5E5E5" borderRadius="6px" overflow="hidden">
                                        <Box h="7px" bg="#F8285A" borderRadius="6px" w={`${pourcentageRecues}%`} maxW="100%" />
                                      </Box>
                                    </Flex>
                                    <Text fontSize="11px" fontWeight="700" color="#171D28" fontFamily="Poppins, sans-serif" minW="50px" textAlign="right">
                                      {medecin.missions_recues || 0} ({medecin.taux_recues?.toFixed(1) || 0}%)
                                    </Text>
                                  </Flex>
                                </VStack>
                              </Flex>
                            </Box>
                          );
                        })}
                      </VStack>
                    </Box>
                  );
                })()}
                {/* Légende */}
                <HStack spacing="20px" justify="flex-start" pt="10px">
                  <HStack spacing="5px">
                    <Box w="10px" h="10px" bg="#006133" borderRadius="10px" />
                    <Text fontSize="13px" fontWeight="400" color="#171D28" fontFamily="Poppins, sans-serif">
                      Missions Envoyées
                    </Text>
                  </HStack>
                  <HStack spacing="5px">
                    <Box w="10px" h="10px" bg="#F8285A" borderRadius="10px" />
                    <Text fontSize="13px" fontWeight="400" color="#171D28" fontFamily="Poppins, sans-serif">
                      Missions Reçues
                    </Text>
                  </HStack>
                </HStack>
              </VStack>
            </Card>

            {/* Deuxième ligne: Deux graphiques côte à côte */}
            <Flex gap="20px" direction={{ base: 'column', lg: 'row' }}>
              {/* Taux de missions envoyées par établissement */}
              <Card
                bg="white"
                border="1px solid #E5E5E5"
                borderRadius="12px"
                boxShadow="0px 0px 10px 0px rgba(0,0,0,0.06)"
                flex="1"
                p="20px"
              >
                <VStack align="stretch" spacing="20px" h="100%">
                  <Text fontSize="14px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                    Taux de missions envoyées / Établissement
                  </Text>
                  {(() => {
                    const envoyeesData = medecinsData.tauxMissionEnvoyees || [];
                    const envoyeesSeries = envoyeesData.map(e => e?.total || 0);
                    // Utiliser le champ \"hopital\" renvoyé par l'API
                    const envoyeesLabels = envoyeesData.map(e => e?.hopital || '');
                    const envoyeesTotal = envoyeesSeries.reduce((acc, val) => acc + val, 0);

                    if (loadingMedecins) {
                      return (
                        <Flex justify="center" align="center" h="300px">
                          <Text color="#656C7A">Chargement...</Text>
                        </Flex>
                      );
                    }

                    if (envoyeesData.length === 0) {
                      return (
                        <Flex justify="center" align="center" h="300px">
                          <Text color="#656C7A">Aucun établissement trouvé</Text>
                        </Flex>
                      );
                    }

                    return (
                      <Flex align="center" justify="center" direction={{ base: 'column', md: 'row' }} gap="20px">
                        {/* Donut Chart */}
                        <Box position="relative" w="200px" h="200px" flexShrink={0}>
                          <Chart
                            type="donut"
                            height={200}
                            series={envoyeesSeries}
                            options={{
                              chart: { type: 'donut', fontFamily: 'Poppins, sans-serif' },
                              labels: envoyeesLabels,
                              colors: ['#006133', '#F6B100', '#34C759', '#006133', '#CB30E0', '#FF6800', '#00BC7C', '#7239EA', '#F8285A', '#656C7A'],
                              plotOptions: { pie: { donut: { size: '70%', labels: { show: false } } } },
                              dataLabels: { enabled: false },
                              legend: { show: false }
                            }}
                          />
                          <Box position="absolute" top="40%" left="50%" transform="translate(-50%, -50%)" textAlign="center">
                            <Text fontSize="24px" fontWeight="600" color="#171D28" fontFamily="Oswald, sans-serif" lineHeight="1.2">
                              {envoyeesTotal}
                            </Text>
                            <Text fontSize="12px" fontWeight="500" color="#656C7A" fontFamily="Poppins, sans-serif">
                              Total
                            </Text>
                          </Box>
                        </Box>
                        {/* Légende */}
                        <Box flex="1" maxH="200px" overflowY="auto" pr="2">
                          <VStack align="stretch" spacing="8px">
                            {envoyeesData.map((etab, index) => {
                              const colors = ['#006133', '#F6B100', '#34C759', '#006133', '#CB30E0', '#FF6800', '#00BC7C', '#7239EA', '#F8285A', '#656C7A'];
                              const color = colors[index % colors.length];
                              const pct = envoyeesTotal > 0 ? (((etab?.total || 0) / envoyeesTotal) * 100).toFixed(1) : 0;
                              // Récupérer le nom d'hôpital depuis le champ \"hopital\"
                              const nomHopital = etab?.hopital || 'Nom non disponible';
                              return (
                                <HStack key={index} spacing="8px" align="center">
                                  <Box w="9px" h="20px" bg={color} borderRadius="10px" flexShrink={0} />
                                  <Text fontSize="12px" fontWeight="400" color="#171D28" fontFamily="Poppins, sans-serif" flex="1" minW="0" noOfLines={1} title={nomHopital}>
                                    {nomHopital}
                                  </Text>
                                  <Text fontSize="12px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif" flexShrink={0} ml="8px">
                                    {etab?.total || 0} ({pct}%)
                                  </Text>
                                </HStack>
                              );
                            })}
                          </VStack>
                        </Box>
                      </Flex>
                    );
                  })()}
                </VStack>
              </Card>

              {/* Taux de missions reçues par établissement */}
              <Card
                bg="white"
                border="1px solid #E5E5E5"
                borderRadius="12px"
                boxShadow="0px 0px 10px 0px rgba(0,0,0,0.06)"
                flex="1"
                p="20px"
              >
                <VStack align="stretch" spacing="20px" h="100%">
                  <Text fontSize="14px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif">
                    Taux de missions reçues / Établissement
                  </Text>
                  {(() => {
                    const recuesData = medecinsData.tauxMissionRecues || [];
                    const recuesSeries = recuesData.map(e => e?.total || 0);
                    // Utiliser le champ \"hopital\" renvoyé par l'API
                    const recuesLabels = recuesData.map(e => e?.hopital || '');
                    const recuesTotal = recuesSeries.reduce((acc, val) => acc + val, 0);

                    if (loadingMedecins) {
                      return (
                        <Flex justify="center" align="center" h="300px">
                          <Text color="#656C7A">Chargement...</Text>
                        </Flex>
                      );
                    }

                    if (recuesData.length === 0) {
                      return (
                        <Flex justify="center" align="center" h="300px">
                          <Text color="#656C7A">Aucun établissement trouvé</Text>
                        </Flex>
                      );
                    }

                    return (
                      <Flex align="center" justify="center" direction={{ base: 'column', md: 'row' }} gap="20px">
                        {/* Donut Chart */}
                        <Box position="relative" w="200px" h="200px" flexShrink={0}>
                          <Chart
                            type="donut"
                            height={200}
                            series={recuesSeries}
                            options={{
                              chart: { type: 'donut', fontFamily: 'Poppins, sans-serif' },
                              labels: recuesLabels,
                              colors: ['#F8285A', '#7239EA', '#FF6800', '#00BC7C', '#656C7A', '#006133', '#F6B100', '#34C759', '#006133', '#CB30E0'],
                              plotOptions: { pie: { donut: { size: '70%', labels: { show: false } } } },
                              dataLabels: { enabled: false },
                              legend: { show: false }
                            }}
                          />
                          <Box position="absolute" top="40%" left="50%" transform="translate(-50%, -50%)" textAlign="center">
                            <Text fontSize="24px" fontWeight="600" color="#171D28" fontFamily="Oswald, sans-serif" lineHeight="1.2">
                              {recuesTotal}
                            </Text>
                            <Text fontSize="12px" fontWeight="500" color="#656C7A" fontFamily="Poppins, sans-serif">
                              Total
                            </Text>
                          </Box>
                        </Box>
                        {/* Légende */}
                        <Box flex="1" maxH="200px" overflowY="auto" pr="2">
                          <VStack align="stretch" spacing="8px">
                            {recuesData.map((etab, index) => {
                              const colors = ['#F8285A', '#7239EA', '#FF6800', '#00BC7C', '#656C7A', '#006133', '#F6B100', '#34C759', '#006133', '#CB30E0'];
                              const color = colors[index % colors.length];
                              const pct = recuesTotal > 0 ? (((etab?.total || 0) / recuesTotal) * 100).toFixed(1) : 0;
                              // Récupérer le nom d'hôpital depuis le champ \"hopital\"
                              const nomHopital = etab?.hopital || 'Nom non disponible';
                              return (
                                <HStack key={index} spacing="8px" align="center">
                                  <Box w="9px" h="20px" bg={color} borderRadius="10px" flexShrink={0} />
                                  <Text fontSize="12px" fontWeight="400" color="#171D28" fontFamily="Poppins, sans-serif" flex="1" minW="0" noOfLines={1} title={nomHopital}>
                                    {nomHopital}
                                  </Text>
                                  <Text fontSize="12px" fontWeight="500" color="#171D28" fontFamily="Poppins, sans-serif" flexShrink={0} ml="8px">
                                    {etab?.total || 0} ({pct}%)
                                  </Text>
                                </HStack>
                              );
                            })}
                          </VStack>
                        </Box>
                      </Flex>
                    );
                  })()}
                </VStack>
              </Card>
            </Flex>
          </VStack>
        </Card>
        )}
      </VStack>

      {/* Modal de détails utilisateur */}
      <Modal isOpen={isUserDetailOpen} onClose={onUserDetailClose} size="lg" isCentered>
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          bg="white"
          borderRadius="12px"
          boxShadow="0px 10px 14px 0px rgba(15,42,81,0.03)"
          maxW="600px"
        >
          <ModalHeader
            borderBottom="1px solid #E5E5E5"
            pb="10px"
            pt="10px"
            px="20px"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Text
              fontSize="16px"
              fontWeight="600"
              color="#171D28"
              fontFamily="Oswald, sans-serif"
              lineHeight="1.2"
            >
              Score {userDetailData?.performance_user?.role === 'ambulancier' ? 'Ambulancier' :
                userDetailData?.performance_user?.role === 'medecin' || userDetailData?.performance_user?.role === 'médecin' ? 'Médecin' :
                  userDetailData?.performance_user?.role === 'infirmier' || userDetailData?.performance_user?.role === 'acte infirmier' ? 'Infirmier' :
                    userDetailData?.performance_user?.role === 'regulateur' ? 'Régulateur' :
                      selectedPerformanceUser?.role === 'ambulancier' ? 'Ambulancier' :
                        selectedPerformanceUser?.role === 'medecin' ? 'Médecin' :
                          selectedPerformanceUser?.role === 'infirmier' || selectedPerformanceUser?.role === 'acte infirmier' ? 'Infirmier' :
                            selectedPerformanceUser?.role === 'regulateur' ? 'Régulateur' : 'Utilisateur'}
            </Text>
            <Button
              variant="ghost"
              size="sm"
              onClick={onUserDetailClose}
              p="7px"
              borderRadius="6px"
              _hover={{ bg: '#F5F5F5' }}
            >
              <Icon as={MdClose} w="18px" h="18px" color="#656C7A" />
            </Button>
          </ModalHeader>
          <ModalBody p="20px">
            {loadingUserDetail ? (
              <LoadingSpinner message="Chargement..." size="sm" />
            ) : userDetailData && userDetailData.performance_user ? (
              <VStack align="stretch" spacing="20px">
                {/* Section Avatar et Nom */}
                <Box borderBottom="1px solid #E5E5E5" pb="20px">
                  <Flex justify="flex-end" align="center">
                    <VStack spacing="14px" flex="1" align="center">
                      {/* Avatar */}
                      {userDetailData.performance_user.photo ? (
                        <Box
                          as="img"
                          src={userDetailData.performance_user.photo}
                          alt={`${userDetailData.performance_user.prenom} ${userDetailData.performance_user.nom}`}
                          w="56px"
                          h="56px"
                          borderRadius="6px"
                          border="1px solid #E5E5E5"
                          objectFit="cover"
                        />
                      ) : (
                        <Box
                          w="56px"
                          h="56px"
                          borderRadius="6px"
                          border="1px solid #E5E5E5"
                          bg="#F0F0F0"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Text fontSize="20px" color="#656C7A" fontWeight="600" fontFamily="Poppins, sans-serif">
                            {userDetailData.performance_user.prenom?.charAt(0).toUpperCase() || userDetailData.performance_user.nom?.charAt(0).toUpperCase() || 'U'}
                          </Text>
                        </Box>
                      )}
                      {/* Nom */}
                      <Text
                        fontSize="16px"
                        fontWeight="600"
                        color="#171D28"
                        fontFamily="Poppins, sans-serif"
                      >
                        {`${userDetailData.performance_user.prenom || ''} ${userDetailData.performance_user.nom || ''}`.trim() || 'Utilisateur'}
                      </Text>
                      {/* Score global */}
                      <Badge
                        bg="#FFF8DD"
                        border="1px solid rgba(246,177,0,0.2)"
                        borderRadius="100px"
                        px="10px"
                        py="5px"
                        display="flex"
                        alignItems="center"
                        gap="5px"
                      >
                        <Text
                          fontSize="13px"
                          fontWeight="600"
                          color="#171D28"
                          fontFamily="Poppins, sans-serif"
                          lineHeight="1.2"
                        >
                          {userDetailData.performance_user.etoile_globale?.toFixed(1) || parseFloat(userDetailData.performance_user.performance_globale || 0).toFixed(1) || '0.0'}
                        </Text>
                        <Icon as={MdStar} w="16px" h="16px" color="#F6B100" fill="#F6B100" />
                      </Badge>
                    </VStack>
                  </Flex>
                </Box>

                {/* Lignes de statistiques */}
                <VStack align="stretch" spacing="0">
                  {/* Temps de réactivité */}
                  <Box
                    border="0.5px dashed #C4CADA"
                    borderRadius="6px"
                    px="11px"
                    py="9px"
                    mb="0"
                  >
                    <Flex justify="space-between" align="center">
                      <Text
                        fontSize="14px"
                        fontWeight="500"
                        color="#171D28"
                        fontFamily="Poppins, sans-serif"
                        lineHeight="1.2"
                      >
                        Temps de réactivité
                      </Text>
                      <Badge
                        bg="#FFF8DD"
                        border="1px solid rgba(246,177,0,0.2)"
                        borderRadius="100px"
                        px="10px"
                        py="5px"
                        display="flex"
                        alignItems="center"
                        gap="5px"
                      >
                        <HStack spacing="5px">
                          {[1, 2, 3, 4, 5].map((star) => {
                            const isFilled = star <= Math.round(userDetailData.performance_user.temps_reactivite?.etoiles || 0);
                            return (
                              <Icon
                                key={star}
                                as={MdStar}
                                w="16px"
                                h="16px"
                                color={isFilled ? '#F6B100' : '#FFFFFF'}
                                fill={isFilled ? '#F6B100' : '#FFFFFF'}
                              />
                            );
                          })}
                        </HStack>
                      </Badge>
                    </Flex>
                  </Box>

                  {/* Respect des délais d'intervention */}
                  <Box
                    border="0.5px dashed #C4CADA"
                    borderTop="none"
                    borderRadius="6px"
                    px="11px"
                    py="9px"
                    mb="0"
                  >
                    <Flex justify="space-between" align="center">
                      <Text
                        fontSize="14px"
                        fontWeight="500"
                        color="#171D28"
                        fontFamily="Poppins, sans-serif"
                        lineHeight="1.2"
                      >
                        Respect des délais d'intervention
                      </Text>
                      <Badge
                        bg="#FFF8DD"
                        border="1px solid rgba(246,177,0,0.2)"
                        borderRadius="100px"
                        px="10px"
                        py="5px"
                        display="flex"
                        alignItems="center"
                        gap="5px"
                      >
                        <HStack spacing="5px">
                          {[1, 2, 3, 4, 5].map((star) => {
                            const isFilled = star <= Math.round(userDetailData.performance_user.respect_delais_intervention?.etoiles || 0);
                            return (
                              <Icon
                                key={star}
                                as={MdStar}
                                w="16px"
                                h="16px"
                                color={isFilled ? '#F6B100' : '#FFFFFF'}
                                fill={isFilled ? '#F6B100' : '#FFFFFF'}
                              />
                            );
                          })}
                        </HStack>
                      </Badge>
                    </Flex>
                  </Box>


                  {/* Satisfaction patient */}
                  <Box
                    border="0.5px dashed #C4CADA"
                    borderTop="none"
                    borderRadius="6px"
                    px="11px"
                    py="9px"
                  >
                    <Flex justify="space-between" align="center">
                      <Text
                        fontSize="14px"
                        fontWeight="500"
                        color="#171D28"
                        fontFamily="Poppins, sans-serif"
                        lineHeight="1.2"
                      >
                        Satisfaction patient
                      </Text>
                      <Badge
                        bg="#FFF8DD"
                        border="1px solid rgba(246,177,0,0.2)"
                        borderRadius="100px"
                        px="10px"
                        py="5px"
                        display="flex"
                        alignItems="center"
                        gap="5px"
                      >
                        <HStack spacing="5px">
                          {[1, 2, 3, 4, 5].map((star) => {
                            const isFilled = star <= Math.round(userDetailData.performance_user.satisfaction_patient?.etoiles || 0);
                            return (
                              <Icon
                                key={star}
                                as={MdStar}
                                w="16px"
                                h="16px"
                                color={isFilled ? '#F6B100' : '#FFFFFF'}
                                fill={isFilled ? '#F6B100' : '#FFFFFF'}
                              />
                            );
                          })}
                        </HStack>
                      </Badge>
                    </Flex>
                  </Box>
                </VStack>
              </VStack>
            ) : (
              <Text fontSize="13px" color="#656C7A" fontFamily="Poppins, sans-serif" textAlign="center" py="40px">
                Aucune donnée disponible
              </Text>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
}
